<template>
  <div>
    <Dialog
      title="Нийтлэх тохиргоо"
      :visible.sync="confirmDialogVisible"
      width="30%"
      append-to-body
    >
      <div v-if="confirmDialogVisible">
        <!-- <Desctiptions>
  <DesctiptionsItem label="Сургалтын нэр">
    {{taskModel.task}}
</DesctiptionsItem>
</Desctiptions>
<p>"{{taskModel.task}}" нь {{taskModel.dueStartDate}} - өдрөөс {{taskModel.dueDate}} хүртэл хугацаанд</p>
<p>Хэрэглэгчийн хүсэлтээр бүртгэх эсэх - {{taskModel.minutes == 1 ? "Тийм":"Үгүй"}}</p> -->
        <ul class="list-group list-group-flush mg-b-0 tx-13">
          <li class="list-group-item pd-x-0  ">
            <span class="tx-rubik tx-bold">{{ taskModel.task }}</span> сургалт
            нь

            <span class="tx-rubik tx-bold">{{
              taskModel.dueStartDate | moment("YYYY.MM.DD HH:mm")
            }}</span>
            өдрөөс
            <span class="tx-rubik tx-bold">{{
              taskModel.dueDate | moment("YYYY.MM.DD HH:mm")
            }}</span>
            хүртэл, нийт
            <span class="tx-rubik tx-bold">{{ diffDays() }}</span> өдрийн
            хугацаанд

            <template v-if="taskModel.flag == 9">
              идэвхтэй байх ба, суралцагч тус бүр сургалтад элссэн өдрөөс эхлэн
              <span class="tx-rubik tx-bold">{{ taskModel.i2 }}</span> хоногийн
              туршид сургалтыг үзэх,
            </template>
          </li>

          <li class="list-group-item pd-x-0 d-flex justify-content-between">
            <span class="tx-medium">Хэрэглэгчийн хүсэлтээр бүртгэх эсэх</span>
            <span class="tx-rubik tx-bold">{{
              taskModel.minutes == 1 ? "Тийм" : "Үгүй"
            }}</span>
          </li>
          <template v-if="taskModel.minutes == 1">
            <li class="list-group-item pd-x-0 d-flex justify-content-between">
              <span class="tx-medium">Анги дүүргэлт</span>
              <span class="tx-rubik tx-bold">{{ taskModel.i3 }}</span>
            </li>
            <li class="list-group-item pd-x-0 d-flex justify-content-between">
              <span class="tx-medium">Бүртгэлийн хугацаа</span>
              <span class="tx-rubik tx-bold"
                >{{ taskModel.d3 | moment("YYYY.MM.DD HH:mm") }} -
                {{ taskModel.d4 | moment("YYYY.MM.DD HH:mm") }}</span
              >
            </li>
          </template>
          <li class="list-group-item pd-x-0 d-flex justify-content-between">
            <span class="tx-medium">Сертификат олгох эсэх</span>
            <span class="tx-rubik tx-bold">{{
              taskModel.i6 == 1 ? "Тийм" : "Үгүй"
            }}</span>
          </li>
          <li class="list-group-item pd-x-0 d-flex justify-content-between">
            <span class="tx-medium">Төлбөртэй эсэх</span>
            <span class="tx-rubik tx-bold">{{
              taskModel.qualityPercChanar == 1 ? "Тийм" : "Үгүй"
            }}</span>
          </li>
          <li
            v-if="taskModel.qualityPercChanar == 1"
            class="list-group-item pd-x-0 d-flex justify-content-between"
          >
            <span class="tx-medium">Төлбөрийн хэмжээ</span>
            <span class="tx-rubik tx-bold">{{ taskModel.budget }}</span>
          </li>
          <li class="list-group-item pd-x-0 d-flex justify-content-right">
            <span class="tx-medium">тохиргоогоор нийтлэх гэж байна.</span>
          </li>
        </ul>
      </div>

      <span slot="footer" class="dialog-footer">
        <Button @click="confirmDialogVisible = false">Болих</Button>
        <Button class="text-white" type="success" @click="onSubmit()"
          >Зөвшөөрч байна.</Button
        >
      </span>
    </Dialog>
    <template v-if="show">
      <b-sidebar
        id="sidebar-right"
        title="Шинэ"
        right
        shadow
        backdrop
        v-model="showSidebar"
        :width="wd"
        @change="visibleChanged"
        :no-close-on-backdrop="true"
        :no-close-on-route-change="true"
        no-header-close
        header-class="pd-0-f wd-100p core-edit-side-header"
      >
        <template v-slot:title>
          <nav class="navbar bd-b d-flex">
            <span>Шинэ</span>

            <button
              @click="visibleChanged(false)"
              class="btn btn-xs btn-uppercase mg-l-auto btn-danger"
            >
              Хаах <feather type="x" class="wd-15-f ht-15-f mg-r-5"></feather>
            </button>
          </nav>
        </template>
        <div class="container">
          <ul
            class="navsecs nav nav-tabs nav-justified"
            id="myTab5"
            role="tablist"
          >
            <li class="nav-item" v-for="(s, si) in sections" :key="si">
              <a
                @click="changeSctn(s)"
                role="button"
                :class="`nav-link ${activeSection == s.id ? 'active' : ''}`"
              >
                {{ s.id }}. {{ s.name }}
                <sup v-if="s.required" class="pd-t-10 pd-l-5 tx-18 tx-danger"
                  >*</sup
                >
              </a>
            </li>
          </ul>
          <div
            class="bg-white bd-l bd-b bd-r"
            style="height: calc(100vh - 170px); overflow: auto; border-radius: 0 0 10px 10px"
          >
            <Form
              ref="formValidate"
              :model="taskModel"
              :rules="rules"
              label-position="top"
              class="course-create-form pd-20"
              style="margin: auto; max-width: 500px; "
            >
              <template
                v-for="(field, i) in fields.filter(
                  (x) => x.sectionId == activeSection
                )"
              >
                <!-- {{ field }} -->
                <!-- <div>{{ field.field }} {{ field.flag }} {{ field.editOrd }} {{ field.title }} {{ field.sectionId }}</div> -->
                <!-- {{field.flag}} -->
                <template v-if="field.flag === 0">
                  <!-- reserved server tald utga hadgalsan -->
                </template>
                <template v-else-if="field.flag === 1">
                  <FormItem
                    v-if="fieldShowCheck(field.field)"
                    :rules="field.rule"
                    :label="`${field.sectionId}.${i + 1} ${field.title}`"
                    :prop="field.field"
                    :key="`lbl_${i}`"
                  >
                    <Input
                      v-if="field.maxlength > 0"
                      :placeholder="field.info"
                      v-model="$data['taskModel'][field.field]"
                      :maxlength="field.maxlength"
                    />
                    <Input
                      v-else
                      :placeholder="field.info"
                      v-model="$data['taskModel'][field.field]"
                    />
                  </FormItem>
                </template>
                <template v-else-if="field.flag === 2">
                  <FormItem
                    v-if="fieldShowCheck(field.field)"
                    :rules="field.rule"
                    :prop="field.field"
                    :label="`${field.sectionId}.${i + 1} ${field.title}`"
                    :key="`lbl_${i}`"
                  >
                    <div slot="label">
                      {{ field.sectionId }}.{{ i + 1 }} {{ field.title }}
                      <Popover
                        :key="`lbl_info_${i}`"
                        placement="top-start"
                        title="Тайлбар"
                        width="400"
                        trigger="hover"
                        :open-delay="200"
                      >
                        <div v-html="infoBuilder(field.info)"></div>
                        <i
                          v-if="field.info != null && field.info != ''"
                          slot="reference"
                          circle
                          class="el-icon-question"
                          type="info"
                        ></i>
                      </Popover>
                    </div>
                    <Input
                      v-if="field.maxlength > 0"
                      v-model="$data['taskModel'][field.field]"
                      type="textarea"
                      placeholder="..."
                      :maxlength="field.maxlength"
                    />
                    <Input
                      v-else
                      v-model="$data['taskModel'][field.field]"
                      type="textarea"
                      placeholder="..."
                    />
                    <!-- <div
                      v-if="field.info != null && field.info != ''"
                      class="text-muted tx-11 eddt-title-info"
                    >
                      {{ infoBuilder(field.info) }}
                    </div> -->
                  </FormItem>
                </template>
                <template v-else-if="field.flag == 3">
                  <FormItem
                    :key="`lbl_${i}`"
                    :rules="field.rule"
                    :prop="field.field"
                    :label="`${field.sectionId}.${i + 1} ${field.title}`"
                  >
                    <div slot="label" style="float: inline-end;">
                      {{ field.sectionId }}.{{ i + 1 }} {{ field.title }}
                      <Popover
                        :key="`lbl_info_${i}`"
                        placement="top-start"
                        title="Тайлбар"
                        width="400"
                        trigger="hover"
                        :open-delay="200"
                      >
                        <div v-html="infoBuilder(field.info)"></div>
                        <i
                          v-if="field.info != null && field.info != ''"
                          slot="reference"
                          circle
                          class="el-icon-question"
                          type="info"
                        ></i>
                      </Popover>
                    </div>
                    <loc-type-cascader
                      :key="`loc_${i}_${field.key}_${myLocKey}`"
                      :id.sync="$data['taskModel'][field.field]"
                      v-model="$data['taskModel'][field.field]"
                      :getParentType="true"
                      :checkStrictly="true"
                      :locTypekey.sync="field.key"
                      :disabled="
                        (taskModel.objectTypeId == 411 && taskModel.id != 0) ||
                          taskModel.objectTypeId == 533
                      "
                    />
                  </FormItem>
                  <!-- <div
                    :key="`lbl_dsc_${i}`"
                    v-if="field.info != null && field.info != ''"
                    class="text-muted tx-11 eddt-title-info"
                  >
                    {{ infoBuilder(field.info) }}
                  </div> -->
                </template>
                <template v-else-if="field.flag == 5">
                  <FormItem
                    v-if="fieldShowCheck(field.field)"
                    :key="`lbl_${i}`"
                    :rules="field.rule"
                    :prop="field.field"
                    :label="`${field.sectionId}.${i + 1} ${field.title}`"
                  >
                    <input
                      type="checkbox"
                      v-model="$data['taskModel'][field.field]"
                    />
                    <div
                      v-if="field.info != null && field.info != ''"
                      class="text-muted tx-11 eddt-title-info"
                    >
                      {{ infoBuilder(field.info) }}
                    </div>
                  </FormItem>
                </template>
                <template v-else-if="field.flag === 6">
                  <FormItem
                    v-if="fieldShowCheck(field.field)"
                    :prop="field.field"
                    :label="`${field.sectionId}.${i + 1} ${field.title}`"
                    :key="`lbl_${i}`"
                    :rules="field.rule"
                  >
                    <div slot="label">
                      {{ field.sectionId }}.{{ i + 1 }} {{ field.title }}
                      <Popover
                        :key="`lbl_info_${i}`"
                        placement="top-start"
                        title="Тайлбар"
                        width="400"
                        trigger="hover"
                        :open-delay="200"
                      >
                        <div v-html="infoBuilder(field.info)"></div>
                        <i
                          v-if="field.info != null && field.info != ''"
                          slot="reference"
                          circle
                          class="el-icon-question"
                          type="info"
                        ></i>
                      </Popover>
                    </div>
                    <VueCtkDateTimePicker
                      locale="mn"
                      v-model="$data['taskModel'][field.field]"
                      no-label
                      format="YYYY-MM-DD HH:mm"
                    />
                    <!-- <div
                      v-if="(field.info != null) & (field.info != '')"
                      class="text-muted tx-11 eddt-title-info"
                    >
                      {{ infoBuilder(field.info) }}
                    </div> -->
                  </FormItem>
                </template>
                <template v-else-if="field.flag === 7">
                  <!-- :value="$data['taskModel'][field.field]"
                          @on-change="(value) => $data['taskModel'][field.field] = value.toLocaleString()+'-01-01T00:00:00'" -->
                  <FormItem
                    :prop="field.field"
                    :label="field.title"
                    :key="`yearpkr7_${i}`"
                  >
                    <DatePicker
                      v-model="$data['taskModel'][field.field]"
                      type="year"
                      placeholder="Select date"
                      style="width: 100%"
                      :format="'yyyy'"
                      :value-format="'yyyy-MM-dd HH:mm:ss'"
                    ></DatePicker>
                    <div class="text-muted tx-11 eddt-title-info">
                      {{ infoBuilder(field.info) }}
                    </div>
                  </FormItem>
                </template>
                <template v-else-if="field.flag === 8">
                  <Divider
                    content-position="left"
                    v-if="fieldShowCheck(field.field)"
                    :key="`dvdr${i}`"
                    >{{ field.title }}</Divider
                  >
                </template>
                <template v-else-if="field.flag === 11">
                  <div :key="`lbl_${i}`">{{ field.title }}</div>
                </template>
                <template v-else-if="field.flag === 12">
                  <!-- {{ field.flag }} -->
                  <FormItem
                    :key="`lbl_${i}`"
                    :rules="field.rule"
                    :prop="field.field"
                    :label="`${field.sectionId}.${i + 1} ${field.title}`"
                  >
                    <div slot="label">
                      {{ field.sectionId }}.{{ i + 1 }} {{ field.title }}
                      <Popover
                        :key="`lbl_info_${i}`"
                        placement="top-start"
                        title="Тайлбар"
                        width="400"
                        trigger="hover"
                        :open-delay="200"
                      >
                        <div v-html="infoBuilder(field.info)"></div>
                        <i
                          v-if="field.info != null && field.info != ''"
                          slot="reference"
                          circle
                          class="el-icon-question"
                          type="info"
                        ></i>
                      </Popover>
                    </div>
                    <RadioGroup v-model="$data['taskModel'][field.field]">
                      <Radio :label="1">
                        <span>Тийм</span>
                      </Radio>
                      <Radio :label="0">
                        <span>Үгүй</span>
                      </Radio>
                    </RadioGroup>
                    <!-- <div
                      v-if="field.info != null && field.info != ''"
                      class="text-muted tx-11 eddt-title-info"
                    >
                      {{ infoBuilder(field.info) }}
                    </div> -->
                  </FormItem>
                </template>
                <template v-else-if="field.flag === 15">
                <!-- <div>end bnu {{ field.field }} {{ field.title }} {{ field.sectionId }} {{ field.editOrd }} {{ field.flag }} </div>  -->
                  <FormItem
                    v-if="fieldShowCheck(field.field)"
                    :key="`lbl_${i}`"
                    :rules="field.rule"
                    :prop="field.field"
                    :label="`${field.sectionId}.${i + 1} ${field.title}`"
                  >
                  <!-- sdf -->
                    <div slot="label">
                      {{ field.sectionId }}.{{ i + 1 }} {{ field.title }}
                      <Popover
                        :key="`lbl_info_${i}`"
                        placement="top-start"
                        title="Тайлбар"
                        width="400"
                        trigger="hover"
                        :open-delay="200"
                      >
                        <div v-html="infoBuilder(field.info)"></div>
                        <i
                          v-if="field.info != null && field.info != ''"
                          slot="reference"
                          circle
                          class="el-icon-question"
                          type="info"
                        ></i>
                      </Popover>
                    </div>

                    <InputNumber
                      v-model="$data['taskModel'][field.field]"
                    ></InputNumber>

                    <span
                      class="text-muted p-l-sm"
                      v-if="$data['taskModel'][field.field] > 999"
                      >{{
                        $data["taskModel"][field.field]
                          | formatMoney(0, ".", ",")
                      }}</span
                    >
                  </FormItem>

                  <!-- <div 
                      
                      class="text-muted tx-11 eddt-title-info"
                    >
                      {{ infoBuilder(field.info) }}
                    </div> -->
                </template>
                <template v-else-if="field.flag === 18">
                  <FormItem
                    :key="`lbl_${i}`"
                    :rules="field.rule"
                    :prop="field.field"
                    :label="`${field.sectionId}.${i + 1} ${field.title}`"
                  >
                    <div slot="label">
                      {{ field.sectionId }}.{{ i + 1 }} {{ field.title }}
                      <Popover
                        :key="`lbl_info_${i}`"
                        placement="top-start"
                        title="Тайлбар"
                        width="400"
                        trigger="hover"
                        :open-delay="200"
                      >
                        <div v-html="infoBuilder(field.info)"></div>
                        <i
                          v-if="field.info != null && field.info != ''"
                          slot="reference"
                          circle
                          class="el-icon-question"
                          type="info"
                        ></i>
                      </Popover>
                    </div>
                    <!-- <div style="clear:both"></div> -->
                    <summernote
                      v-if="!$store.state.app.isMobile"
                      v-model="$data['taskModel'][field.field]"
                      :text="$data['taskModel'][field.field]"
                    ></summernote>
                    <Input
                      v-else-if="field.maxlength > 0"
                      v-model="$data['taskModel'][field.field]"
                      type="textarea"
                      :maxlength="field.maxlength"
                    />
                    <Input
                      v-else
                      v-model="$data['taskModel'][field.field]"
                      type="textarea"
                    />
                    <!-- <div
                      v-if="field.info != null && field.info != ''"
                      class="text-muted tx-11 eddt-title-info"
                    >
                      {{ infoBuilder(field.info) }}
                    </div> -->
                  </FormItem>
                </template>

                <template v-else-if="field.flag == 20">
                  <FormItem
                    :key="`lbl_${i}`"
                    :rules="field.rule"
                    :prop="field.field"
                    :label="field.title"
                  >
                    <loctype-multiple-tag
                      v-model="$data['taskModel'][field.field]"
                      :ids.sync="$data['taskModel'][field.field]"
                      :lkey.sync="field.key"
                      :hideIcon="true"
                    ></loctype-multiple-tag>
                    <div class="text-muted tx-11 eddt-title-info">
                      {{ infoBuilder(field.info) }}
                    </div>
                  </FormItem>
                </template>

                <template v-else-if="field.flag === 22">
                  <FormItem
                    :key="`lbl_${i}`"
                    :rules="field.rule"
                    :prop="field.field"
                    :label="field.title"
                  >
                    <div slot="label">
                      {{ field.sectionId }}.{{ i + 1 }} {{ field.title }}
                      <Popover
                        :key="`lbl_info_${i}`"
                        placement="top-start"
                        title="Тайлбар"
                        width="400"
                        trigger="hover"
                        :open-delay="200"
                      >
                        <div v-html="infoBuilder(field.info)"></div>
                        <i
                          v-if="field.info != null && field.info != ''"
                          slot="reference"
                          circle
                          class="el-icon-question"
                          type="info"
                        ></i>
                      </Popover>
                    </div>
                    <!-- <InputNumber v-model="$data['taskModel'][field.field]"></InputNumber> -->
                    <Checkbox v-model="$data['taskModel'][field.field]" />
                    <!-- <div class="text-muted tx-11 eddt-title-info">
                      {{ infoBuilder(field.info) }}
                    </div> -->
                  </FormItem>
                </template>
                <template v-else-if="field.flag === 24">
                  <FormItem
                    :rules="field.rule"
                    :prop="field.field"
                    :label="field.title"
                    :key="`lbl_${i}`"
                  >
                    <div slot="label">
                      {{ field.sectionId }}.{{ i + 1 }} {{ field.title }}
                      <Popover
                        :key="`lbl_info_${i}`"
                        placement="top-start"
                        title="Тайлбар"
                        width="400"
                        trigger="hover"
                        :open-delay="200"
                      >
                        <div v-html="infoBuilder(field.info)"></div>
                        <i
                          v-if="field.info != null && field.info != ''"
                          slot="reference"
                          circle
                          class="el-icon-question"
                          type="info"
                        ></i>
                      </Popover>
                    </div>
                    <!-- {{  field.field }} -->
                    <task-finder
                      v-model="$data['taskModel'][field.field]"
                      :selectedId="$data['taskModel'][field.field]"
                      @on-task-selected="field.cstmFld2 = $event.task"
                      :objectTypeId.sync="[field.key][0]"
                      :fieldName="field.field"
                      :prmsProp="prms"
                      :key="`tsk_${i}`"
                      :parentTaskId="
                        prms.parentTask != null ? prms.parentTask.id : 0
                      "
                    ></task-finder>
                    <!-- <div class="text-muted tx-11 eddt-title-info">
                      {{ infoBuilder(field.info) }}
                    </div> -->
                  </FormItem>
                </template>
                <template v-else-if="field.flag === 25">
                  <span :key="`lbl_${i}`" style="display: none">{{
                    ($data["taskModel"]["task"] = "гарчиггүй")
                  }}</span>
                </template>
                <template v-else-if="field.flag === 30">
                  <FormItem
                    v-if="fieldShowCheck(field.field)"
                    :rules="field.rule"
                    :prop="field.field"
                    :label="field.title"
                    :key="`lbl_${i}`"
                  >
                    <div slot="label">
                      {{ field.sectionId }}.{{ i + 1 }} {{ field.title }}
                      <Popover
                        :key="`lbl_info_${i}`"
                        placement="top-start"
                        title="Тайлбар"
                        width="400"
                        trigger="hover"
                        :open-delay="200"
                      >
                        <div v-html="infoBuilder(field.info)"></div>
                        <i
                          v-if="field.info != null && field.info != ''"
                          slot="reference"
                          circle
                          class="el-icon-question"
                          type="info"
                        ></i>
                      </Popover>
                    </div>
                    <depart-cascader
                      :checkStrictly="true"
                      :id="$data['taskModel'][field.field]"
                      v-model="$data['taskModel'][field.field]"
                    />
                    <!-- <div class="text-muted tx-11 eddt-title-info">
                      {{ infoBuilder(field.info) }}
                    </div> -->
                  </FormItem>
                </template>
                <template v-else-if="field.flag === 31">
                  <div :key="`lbl_${i}`" v-if="fieldShowCheck(field.field)">
                    <FormItem
                      :rules="field.rule"
                      :prop="field.field"
                      :label="`${field.sectionId}.${i + 1} ${field.title}`"
                      :key="`lbl_${i}`"
                    >
                      <div slot="label">
                        {{ field.sectionId }}.{{ i + 1 }} {{ field.title }}
                        <Popover
                          :key="`lbl_info_${i}`"
                          placement="top-start"
                          title="Тайлбар"
                          width="400"
                          trigger="hover"
                          :open-delay="200"
                        >
                          <div v-html="infoBuilder(field.info)"></div>
                          <i
                            v-if="field.info != null && field.info != ''"
                            slot="reference"
                            circle
                            class="el-icon-question"
                            type="info"
                          ></i>
                        </Popover>
                      </div>
                      <simple-uploader
                        v-model="$data['taskModel'][field.field]"
                        :propBoxId="0"
                        :propObjectId="'0'"
                        :propAccept="field.cstmFld1"
                        :propObjectTypeId="$data['taskModel']['objectTypeId']"
                        @on-success="fileUploaded($event, field)"
                      >
                        <div slot="trigger">
                          <div
                            v-if="$data['taskModel'][field.key] == ''"
                            class="btn-group wd-100p"
                          >
                            <div class="btn btn-outline-success">
                              <feather type="upload" class="mg-r-5"></feather>
                              <span>Компьютероос хуулах</span>
                            </div>
                            <div
                              @click.stop="showFinder(field)"
                              class="btn btn-outline-primary"
                            >
                              <feather type="archive" class="mg-r-5"></feather>
                              <span>Динамик драйваас сонгох</span>
                            </div>
                          </div>
                          <div v-else class="btn-group wd-100p">
                            <div
                              @click.stop="
                                $emit(
                                  'on-attach',
                                  $data['taskModel'][field.field]
                                )
                              "
                              class="btn btn-outline-success"
                            >
                              <feather type="eye"></feather>Файл харах
                            </div>
                            <div
                              class="btn btn-danger"
                              @click.prevent.stop="
                                $data['taskModel'][field.field] = null;
                                $data['taskModel'][field.key] = '';
                              "
                            >
                              <feather type="x"></feather>Салгах
                            </div>
                          </div>
                        </div>
                      </simple-uploader>
                      <!-- <div
                        v-if="field.info != null && field.info != ''"
                        class="text-muted tx-11 eddt-title-info"
                      >
                        {{ infoBuilder(field.info) }}
                      </div> -->
                    </FormItem>
                  </div>
                </template>
                <template v-else-if="field.flag === 36">
                  <span :key="`lbl_${i}`" style="display: none">{{
                    ($data["taskModel"]["parentId"] = 0)
                  }}</span>
                </template>
                <template v-else-if="field.flag === 39"></template>
                <template v-else-if="field.flag === 42">
                  <FormItem
                    :label="field.title"
                    class="m-b-xs"
                    :key="`lbl_${i}`"
                  >
                    <!-- Web component selector 355 -->
                    <Input
                      :maxlength="field.maxlength"
                      v-if="prms.parentId == 0"
                      v-model="$data['taskModel'][field.field]"
                    />
                    <Select
                      v-else
                      v-model="$data['taskModel'][field.field]"
                      filterable
                      clearable
                    >
                      <Option
                        :value="tw.st1"
                        v-for="(tw, twi) in webComponents"
                        :key="twi"
                        :label="tw.task"
                      >
                        {{ tw.task }}
                        <div class="p-l-sm" style="float: right; color: #ccc">
                          {{ tw.st2 }}
                        </div>
                      </Option>
                    </Select>
                  </FormItem>
                </template>
                <template v-else-if="field.flag === 49">
                  <!-- reserved server tald utga hadgalsan -->
                </template>
                <template v-else-if="field.flag === 50">
                  <FormItem
                    :rules="field.rule"
                    :prop="field.field"
                    :label="field.title"
                    :key="`lbl_${i}`"
                  >
                    <div
                      v-if="
                        prms.parentTask != undefined &&
                          $data['taskModel'][field.field] == null
                      "
                    >
                      <span style="display: none">{{
                        ($data["taskModel"][field.field] = prms.parentTask.id)
                      }}</span>
                    </div>
                    <task-finder
                      v-model="$data['taskModel'][field.field]"
                      :selectedId="$data['taskModel'][field.field]"
                      @on-task-selected="onTaskSelected(field, $event)"
                      :objectTypeId.sync="[field.key][0]"
                      :key="`tsk_${i}`"
                    ></task-finder>
                    <div class="text-muted tx-11 eddt-title-info">
                      {{ infoBuilder(field.info) }}
                    </div>
                  </FormItem>
                </template>
                <template v-else-if="field.flag === 51">
                  <FormItem
                    :key="`lbl_${i}`"
                    :rules="field.rule"
                    :prop="field.field"
                    :label="field.title"
                  >
                    <loctype-multiple-tag
                      v-model="$data['taskModel'][field.field]"
                      :ids.sync="$data['taskModel'][field.field]"
                      :lkey.sync="
                        field.key + '_' + $data['taskModel']['projectId']
                      "
                    ></loctype-multiple-tag>
                    <div class="text-muted tx-11 eddt-title-info">
                      {{ infoBuilder(field.info) }}
                    </div>
                  </FormItem>
                </template>
                <template v-else-if="field.flag === 53">
                  <FormItem
                    v-if="taskModel.minutes == 1"
                    :key="`lbl_${i}`"
                    :rules="field.rule"
                    :prop="field.field"
                    :label="`${field.sectionId}.${i + 1} ${field.title}`"
                    class="m-b-xs"
                  >
                    <div slot="label">
                      {{ field.sectionId }}.{{ i + 1 }} {{ field.title }}
                      <Popover
                        :key="`lbl_info_${i}`"
                        placement="top-start"
                        title="Тайлбар"
                        width="400"
                        trigger="hover"
                        :open-delay="200"
                      >
                        <div v-html="infoBuilder(field.info)"></div>
                        <i
                          v-if="field.info != null && field.info != ''"
                          slot="reference"
                          circle
                          class="el-icon-question"
                          type="info"
                        ></i>
                      </Popover>
                    </div>
                    <Select
                      v-model="$data['taskModel'][field.field]"
                      filterable
                      @change="registrationMemberOptionChanged(field, $event)"
                    >
                      <!-- <Option :value="0" :key="0" :label="'Цоожтой'"
                        >Цоожтой</Option
                      > -->
                      <Option :value="1" :key="1" :label="'Нээлттэй'"
                        >Нээлттэй</Option
                      >
                      <Option
                        :value="2"
                        :key="2"
                        :label="'Хүсэлт илгээх боломжтой (гишүүд)'"
                        >Хүсэлт илгээх боломжтой (гишүүд)</Option
                      >
                      <Option
                        :value="3"
                        :key="3"
                        :label="
                          'Хүсэлт илгээх боломжтой (бүртгүүлсэн хэрэглэгч)'
                        "
                        >Хүсэлт илгээх боломжтой (бүртгүүлсэн хэрэглэгч)</Option
                      >
                      <Option
                        :value="9900"
                        :key="9900"
                        :label="'Сонгогдсон хавчуурга заавал хамрагдах'"
                        >Сонгогдсон хавчуурга заавал хамрагдах</Option
                      >
                    </Select>
                    <!-- <div class="text-muted tx-11 eddt-title-info">
                      {{ infoBuilder(field.info) }}
                    </div> -->
                  </FormItem>
                </template>
                <template v-else-if="field.flag === 54">
                  <FormItem
                    :key="`lbl_${i}`"
                    :rules="field.rule"
                    :prop="field.field"
                    :label="field.title"
                    class="m-b-xs"
                  >
                    <div slot="label">
                      {{ field.sectionId }}.{{ i + 1 }} {{ field.title }}
                      <Popover
                        :key="`lbl_info_${i}`"
                        placement="top-start"
                        title="Тайлбар"
                        width="400"
                        trigger="hover"
                        :open-delay="200"
                        :content="infoBuilder(field.info)"
                      >
                        <i
                          v-if="field.info != null && field.info != ''"
                          slot="reference"
                          circle
                          class="el-icon-question"
                          type="info"
                        ></i>
                      </Popover>
                    </div>
                    <Select
                      v-model="$data['taskModel'][field.field]"
                      filterable
                      clearable
                    >
                      <Option :key="0" :value="0" :label="'Тийм'">Тийм</Option>
                      <Option :key="1" :value="1" :label="'Шаардлагагүй'"
                        >Шаардлагагүй</Option
                      >
                    </Select>
                    <!-- <div class="text-muted tx-11 eddt-title-info">
                      {{ infoBuilder(field.info) }}
                    </div> -->
                  </FormItem>
                </template>
                <template v-else-if="field.flag === 55">
                  <FormItem
                    :key="`lbl_${i}`"
                    :rules="field.rule"
                    :prop="field.field"
                    :label="`${field.sectionId}.${i + 1} ${field.title}`"
                    class="m-b-xs"
                  >
                    <Select
                      v-model="$data['taskModel'][field.field]"
                      filterable
                    >
                      <Option :key="0" :value="0" :label="'Зөвхөн шалгалтаар'"
                        >Зөвхөн шалгалтаар</Option
                      >
                      <Option
                        :key="1"
                        :value="1"
                        :label="'Нэмэлт оноо тооцно /Явц + Ирц + Шалгалт/'"
                        >Нэмэлт оноо тооцно /Явц + Ирц + Шалгалт/</Option
                      >
                    </Select>
                    <div
                      v-show="field.info != null && field.info != ''"
                      class="text-muted tx-11 eddt-title-info"
                    >
                      {{ infoBuilder(field.info) }}
                    </div>
                  </FormItem>
                </template>
                <template v-else-if="field.flag === 56">
                  <FormItem
                    v-if="fieldShowCheck(field.field)"
                    :key="`lbl_${i}`"
                    :rules="field.rule"
                    :prop="field.field"
                    :label="`${field.sectionId}.${i + 1} ${field.title}`"
                    class="m-b-xs"
                  >
                    <div slot="label">
                      {{ field.sectionId }}.{{ i + 1 }} {{ field.title }}
                      <Popover
                        :key="`lbl_info_${i}`"
                        placement="top-start"
                        title="Тайлбар"
                        width="400"
                        trigger="hover"
                        :open-delay="200"
                      >
                        <div v-html="infoBuilder(field.info)"></div>
                        <i
                          v-if="field.info != null && field.info != ''"
                          slot="reference"
                          circle
                          class="el-icon-question"
                          type="info"
                        ></i>
                      </Popover>
                    </div>
                    <Select
                      v-model="$data['taskModel'][field.field]"
                      filterable
                    >
                      <Option :key="0" :value="0" :label="'Үгүй'">Үгүй</Option>
                      <Option :key="1" :value="1" :label="'Тийм'">Тийм</Option>
                    </Select>
                    <!-- <div
                      v-show="field.info != null && field.info != ''"
                      class="text-muted tx-11 eddt-title-info"
                    >
                      {{ infoBuilder(field.info) }}
                    </div> -->
                  </FormItem>
                </template>
                <template v-else-if="field.flag === 57">
                  <FormItem
                    :key="`lbl_${i}`"
                    :rules="field.rule"
                    :prop="field.field"
                    :label="field.title"
                    class="m-b-xs"
                  >
                    <Select
                      v-model="$data['taskModel'][field.field]"
                      filterable
                    >
                      <Option
                        :key="1"
                        :value="1"
                        :label="'Зөвхөн хичээлд хавсаргасан хүмүүс үзэх эрхтэй'"
                        >Зөвхөн хичээлд хавсаргасан хүмүүс үзэх эрхтэй</Option
                      >
                      <Option
                        :key="0"
                        :value="0"
                        :label="
                          'Сургалттад хавсаргагдсан бүх хүмүүс үзэх эрхтэй'
                        "
                        >Сургалтад хавсаргагдсан бүх хүмүүс үзэх эрхтэй</Option
                      >
                    </Select>
                    <div class="text-muted tx-11 eddt-title-info">
                      {{ infoBuilder(field.info) }}
                    </div>
                  </FormItem>
                </template>
                <template v-else-if="field.flag === 59">
                  <FormItem
                    :rules="field.rule"
                    :prop="field.field"
                    :label="field.title"
                    :key="`lbl_${i}`"
                  >
                    <div
                      v-if="
                        prms.parentTask != undefined &&
                          $data['taskModel'][field.field] == null
                      "
                    >
                      <span style="display: none">{{
                        ($data["taskModel"][field.field] = prms.parentTask.id)
                      }}</span>
                    </div>
                    <task-finder
                      v-model="$data['taskModel'][field.field]"
                      :selectedId="$data['taskModel'][field.field]"
                      @on-task-selected="field.cstmFld2 = $event.task"
                      :objectTypeId.sync="[field.key][0]"
                      :key="`tsk_${i}`"
                    ></task-finder>
                    <div class="text-muted tx-11 eddt-title-info">
                      {{ infoBuilder(field.info) }}
                    </div>
                  </FormItem>
                </template>
                <template v-else-if="field.flag === 60">
                  <FormItem
                    :rules="field.rule"
                    :prop="field.field"
                    :label="field.title"
                    :key="`lbl_${i}`"
                  >
                    <div
                      v-if="
                        prms.parentTask != undefined &&
                          $data['taskModel'][field.field] == null
                      "
                    >
                      <span style="display: none">{{
                        ($data["taskModel"][field.field] = prms.parentTask.id)
                      }}</span>
                    </div>
                    <loc-type-cascader-assign-task
                      :id="$data['taskModel'][field.field]"
                      :txt="$data['taskModel'][field.key.split(':')[1]]"
                      v-model="$data['taskModel'][field.field]"
                      :getParentType="true"
                      :locTypekey="field.key"
                      :otherTxt="field.info"
                      @loctype-selected="locTypeAssignTask"
                    />
                    <div class="text-muted tx-11 eddt-title-info">
                      {{ infoBuilder(field.info) }}
                    </div>
                  </FormItem>
                </template>
                <template v-else-if="field.flag === 63">
                  <!-- //{{orgSelectedId =  -->
                  <!-- //if(isNaN(this.orgSelectedId))
            //this.orgSelectedId = null;
                      //}}-->
                  <FormItem
                    :key="`lbl_${i}`"
                    :rules="field.rule"
                    :prop="field.field"
                    :label="field.title"
                  >
                    <!-- <div :key="`lbl_${i}`" v-if="!hasPerr(['crmlicenseacceptor'])">
                        {{$data['taskModel'][field.field] = parseInt($store.state.user.defaultTasks['organizationTaskId'], 10)}}
                        </div>-->
                    <crm-user-default-company-selecter
                      :selectedId="$data['taskModel'][field.field]"
                      v-model="$data['taskModel'][field.field]"
                    ></crm-user-default-company-selecter>

                    <div class="text-muted tx-11 eddt-title-info">
                      {{ infoBuilder(field.info) }}
                    </div>
                  </FormItem>
                </template>

                <template v-else-if="field.flag === 68">
                  <FormItem
                    v-if="taskModel.minutes == 1 && fieldShowCheck(field.field)"
                    :key="`lbl_${i}`"
                    :rules="field.rule"
                    :prop="field.field"
                    :label="`${field.sectionId}.${i + 1} ${field.title}`"
                  >
                    <hrm-tag-assign
                      :editKey="field.key"
                      :fld="$data['taskModel'][field.field]"
                      v-model="$data['taskModel'][field.field]"
                    ></hrm-tag-assign>
                    <div
                      v-show="field.info != null && field.info != ''"
                      class="text-muted tx-11 eddt-title-info"
                    >
                      {{ infoBuilder(field.info) }}
                    </div>
                  </FormItem>
                </template>
                <template v-else-if="field.flag === 69">
                  <!-- {{field}} -->
                  <FormItem
                    :rules="field.rule"
                    :prop="field.field"
                    :label="field.title"
                    :key="`lbl_${i}`"
                  >
                    <loc-type-cascader-with-field
                      :ref="`ltCasWF_${field.field}`"
                      @on-change="locTypeFieldOnChange($event, field.field)"
                      @on-data-fired="locTypeCascaderOnDataFired(field)"
                      :id="$data['taskModel'][field.field]"
                      v-model="$data['taskModel'][field.field]"
                      :getParentType="true"
                      :locTypekey="field.key"
                      :key="locTypeId4IncrementKey"
                      :disabled="disableLocTypeCascaderWithField"
                    />
                    <div class="text-muted tx-11 eddt-title-info">
                      {{ infoBuilder(field.info) }}
                    </div>
                  </FormItem>
                  <template v-if="locTypeFields.draw">
                    <Divider
                      v-if="locTypeFields.fields.length > 0"
                      :key="`dvd_${i}`"
                      >Хүчин зүйл</Divider
                    >
                    <div v-else :key="`dvd1_${i}`">
                      <FormItem label="Хүчин зүйл" :key="`lbl_${i}`">
                        <div
                          role="alert"
                          class="
                                alert alert-info
                                fade
                                show
                                pd-0 pd-l-15
                                mg-b-0
                              "
                        >
                          <strong>Хүчин зүйл тохируулаагүй байна.</strong>
                        </div>
                      </FormItem>
                    </div>
                    <!-- <Form
                    :model="locTypeFields.model"
                    ref="formValidate"
                    label-width="30%"
                    style="background: rgba(0,0,0,0.05)"
                    class="p-sm"
                        >-->
                    <!-- {{locTypeFields.fields}} -->
                    <div
                      v-for="(f, i) in locTypeFields.fields"
                      :key="i"
                      class="ltfs bg-gray-100 pd-l-10"
                    >
                      <!-- f.type=> {{f.property.type}} -->

                      <!-- {{f.property.type}} -->

                      <template
                        v-if="f.property.type == 1 || f.property.type == 2"
                      >
                        <FormItem
                          :class="{
                            'is-error': f.property.isValid == false,
                            'is-required': f.property.rule.required,
                          }"
                          :label="f.property.title"
                        >
                          <Select
                            v-if="taskModel.id == 0"
                            @change="
                              locTypeFieldOnSet(f.property.type, $event, f)
                            "
                            :multiple="f.property.type == 2"
                            collapse-tags
                            v-model="f.property.value"
                            style="width: 100%"
                            size="medium"
                          >
                            <Option
                              :key="vi"
                              v-for="(v, vi) in f.property.values"
                              :value="v.id"
                              :label="v.value"
                              >{{ v.value }}</Option
                            >
                          </Select>
                          <Select
                            v-else
                            @change="
                              locTypeFieldOnSet(f.property.type, $event, f)
                            "
                            v-model="f.property.value"
                            :multiple="f.property.type == 2"
                            collapse-tags
                          >
                            <Option
                              :key="vi"
                              v-for="(v, vi) in f.property.values"
                              :value="v.id"
                              :label="v.value"
                              >{{ v.value }} {{ v.id }}</Option
                            >
                          </Select>

                          <div
                            class="el-form-item__error"
                            v-show="f.property.isValid == false"
                          >
                            {{ f.property.rule.message }}
                          </div>
                        </FormItem>
                      </template>
                      <template v-else-if="f.property.type == 3">
                        <FormItem
                          :label="f.property.title"
                          :key="`ff_` + f.id"
                          :class="{
                            'is-error': f.property.isValid == false,
                            'is-required': f.property.rule.required,
                          }"
                        >
                          <Input
                            type="textarea"
                            :rows="3"
                            v-if="taskModel.id == 0 || ltFieldOnReset"
                            @change="
                              locTypeFieldOnSet(f.property.type, $event, f)
                            "
                            :maxlength="450"
                            v-model="f.property.value"
                          />
                          <!-- v-model="f.property.selectedValues[0]" -->
                          <Input
                            type="textarea"
                            :rows="3"
                            v-else
                            @change="
                              locTypeFieldOnSet(f.property.type, $event, f)
                            "
                            v-model="f.property.selectedValues[0]"
                            :maxlength="450"
                          />
                          <!-- {{f.property}} -->
                          <div
                            class="el-form-item__error"
                            v-show="f.property.isValid == false"
                          >
                            {{ f.property.rule.message }}
                          </div>
                        </FormItem>
                      </template>
                      <template v-else-if="f.property.type == 4">
                        <!-- {{f.property.selectedValues}}
                            {{f.property.value}} -->
                        <FormItem
                          :class="{
                            'is-error': f.property.isValid == false,
                            'is-required': f.property.rule.required,
                          }"
                          :label="
                            f.property.title +
                              (f.property.measure != ''
                                ? ' (' + f.property.measure + ')'
                                : '')
                          "
                        >
                          <!-- {{f.property.value}} {{f.property.selectedValues[0]}} -->
                          <!-- <Button @click="locTypeFieldOnSet(f.property.type, 5, f)">set 5</Button> -->
                          <InputNumber
                            v-if="taskModel.id == 0"
                            @change="
                              locTypeFieldOnSet(f.property.type, $event, f)
                            "
                            v-model="f.property.value"
                          />
                          <InputNumber
                            v-else
                            @change="
                              locTypeFieldOnSet(f.property.type, $event, f)
                            "
                            v-model="f.property.selectedValues[0]"
                          />
                          <span
                            class="text-muted p-l-sm"
                            v-if="f.property.selectedValues[0] > 999"
                            >{{
                              f.property.selectedValues[0]
                                | formatMoney(0, ".", ",")
                            }}</span
                          >
                          <div
                            class="el-form-item__error"
                            v-show="f.property.isValid == false"
                          >
                            {{ f.property.rule.message }}
                          </div>
                        </FormItem>
                      </template>
                      <template v-else-if="f.property.type == 5">
                        <!-- ene mon v -->
                        <FormItem
                          :class="{
                            'is-error': f.property.isValid == false,
                            'is-required': f.property.rule.required,
                          }"
                          :label="f.property.title"
                        >
                          <DatePicker
                            v-if="taskModel.id == 0"
                            @change="
                              locTypeFieldOnSet(f.property.type, $event, f)
                            "
                            v-model="f.property.value"
                            placeholder="Огноо сонгоно уу"
                            type="date"
                            :format="'yyyy-MM-dd'"
                            :value-format="'yyyy-MM-dd'"
                            style="width: 100%"
                          ></DatePicker>
                          <DatePicker
                            v-else
                            @change="
                              locTypeFieldOnSet(f.property.type, $event, f)
                            "
                            v-model="f.property.selectedValues[0]"
                            placeholder="Огноо сонгоно уу"
                            type="date"
                            :format="'yyyy-MM-dd'"
                            :value-format="'yyyy-MM-dd'"
                            style="width: 100%"
                          ></DatePicker>
                          <div
                            class="el-form-item__error"
                            v-show="f.property.isValid == false"
                          >
                            {{ f.property.rule.message }}
                          </div>
                        </FormItem>
                      </template>

                      <template v-else-if="f.property.type == 6">
                        <FormItem
                          width="auto"
                          :class="{
                            'is-error': f.property.isValid == false,
                            'is-required': f.property.rule.required,
                          }"
                          :label="
                            f.property.title +
                              (f.property.measure != ''
                                ? ' (' + f.property.measure + ')'
                                : '')
                          "
                        >
                          <simple-uploader
                            :propBoxId="0"
                            :propObjectId="'0'"
                            :propObjectTypeId="6"
                            @on-success="fileUploadedProperty($event, f)"
                          >
                            <div slot="trigger">
                              <div
                                v-if="
                                  f.property.value == null ||
                                    f.property.value == undefined ||
                                    f.property.value == ''
                                "
                                class="btn-group wd-100p"
                              >
                                <div class="btn btn-outline-success">
                                  <feather
                                    type="upload"
                                    class="mg-r-5"
                                  ></feather>
                                  <span>Компьютероос хуулах</span>
                                </div>
                                <div
                                  @click.stop="showFinder(f, 2)"
                                  class="btn btn-outline-primary"
                                >
                                  <feather
                                    type="archive"
                                    class="mg-r-5"
                                  ></feather>
                                  <span>Динамик драйваас сонгох</span>
                                </div>
                              </div>
                              <div v-else class="btn-group wd-100p">
                                <div
                                  @click.stop="
                                    $emit('on-attach', f.property.value)
                                  "
                                  class="btn btn-outline-success"
                                >
                                  <feather type="eye"></feather>Файл харах
                                </div>
                                <div
                                  class="btn btn-danger"
                                  @click.prevent.stop="
                                    locTypeFieldOnSet(f.property.type, null, f)
                                  "
                                >
                                  <feather type="x"></feather>Салгах
                                </div>
                              </div>
                            </div>
                          </simple-uploader>

                          <div
                            class="el-form-item__error"
                            v-show="f.property.isValid == false"
                          >
                            {{ f.property.rule.message }}
                          </div>
                        </FormItem>
                      </template>
                      <template v-else-if="f.property.type == 7">
                        <!-- <Divider :key="`dvd_${i}`" >{{ f.property.title }}</Divider> -->
                        <div class="bd-y bd-1 pd-10 bg-gray-200">
                          {{ f.property.title }}
                        </div>
                      </template>

                      <div
                        v-if="f.property.info != ''"
                        class="alert alert-warning alert-dismissible fade show"
                        role="alert"
                      >
                        <strong>Санамж</strong> {{ f.property.info }}
                      </div>
                    </div>
                    <!-- </Form> -->
                  </template>
                </template>
                <template v-else-if="field.flag === 70">
                  <FormItem
                    :rules="field.rule"
                    :prop="field.field"
                    :label="field.title"
                    :key="`lbl_${i}`"
                  >
                    <simple-uploader
                      v-model="$data['taskModel'][field.field]"
                      :propBoxId="0"
                      :propObjectId="'0'"
                      :propObjectTypeId="$data['taskModel']['objectTypeId']"
                      @on-success="fileUploaded($event, field)"
                    >
                      <div slot="trigger">
                        <div
                          v-if="$data['taskModel'][field.key] == ''"
                          class="btn-group wd-100p"
                        >
                          <div class="btn btn-outline-success">
                            <feather type="upload" class="mg-r-5"></feather>
                            <span>Компьютероос хуулах</span>
                          </div>
                          <div
                            @click.stop="showFinder(field)"
                            class="btn btn-outline-primary"
                          >
                            <feather type="archive" class="mg-r-5"></feather>
                            <span>Динамик драйваас сонгох</span>
                          </div>
                        </div>
                        <div v-else class="btn-group wd-100p">
                          <div
                            @click.stop="
                              $emit(
                                'on-attach',
                                $data['taskModel'][field.field]
                              )
                            "
                            class="btn btn-outline-success"
                          >
                            <feather type="eye"></feather>Файл харах
                          </div>
                          <div
                            class="btn btn-danger"
                            @click.prevent.stop="
                              $data['taskModel'][field.field] = null;
                              $data['taskModel'][field.key] = '';
                            "
                          >
                            <feather type="x"></feather>Салгах
                          </div>
                        </div>
                      </div>
                    </simple-uploader>
                    <div class="text-muted tx-11 eddt-title-info">
                      {{ infoBuilder(field.info) }}
                    </div>
                  </FormItem>
                </template>
                <template v-else-if="field.flag === 74">
                  <FormItem
                    :key="`lbl_${i}`"
                    :rules="field.rule"
                    :prop="field.field"
                    :label="field.title"
                  >
                    <template v-if="hasPerr(['assetevaluation'])">
                      <span style="display: none">{{
                        ($data["taskModel"][field.field] = true)
                      }}</span>
                      <Checkbox
                        :disabled="true"
                        v-model="$data['taskModel'][field.field]"
                      ></Checkbox>
                    </template>
                    <Checkbox
                      v-else
                      v-model="$data['taskModel'][field.field]"
                    ></Checkbox>
                    <div class="text-muted tx-11 eddt-title-info">
                      {{ infoBuilder(field.info) }}
                    </div>
                  </FormItem>
                </template>
                <template v-else-if="field.flag === 75">
                  <!-- :rules="field.rule" -->
                  <FormItem
                    :key="`lbl_${i}`"
                    :prop="field.field"
                    :label="field.title"
                  >
                    <RadioGroup
                      v-model="createdUser.mode"
                      @on-change="createdUserChanged"
                    >
                      <Radio label="1">
                        <span v-if="$store.state.app.activeGroup.id == 9298"
                          >Иргэний бүртгэлийн дугаар</span
                        >
                        <span v-else>Нэвтрэх нэр (Бүртгэл №)</span>
                      </Radio>
                      <Radio
                        label="2"
                        v-if="$store.state.app.activeGroup.id != 9298"
                      >
                        <span>Регистр №</span>
                      </Radio>
                      <Radio label="3">
                        <span>Нэр</span>
                      </Radio>
                    </RadioGroup>
                    <Input v-model="createdUser.value">
                      <!-- enter-button="Хайх" -->
                      <!-- search -->
                      <a
                        @click="createdUserRemove"
                        v-if="
                          createdUser.field != null ||
                            $data['taskModel']['secondUserId'] != null
                        "
                        class="btn btn-ligh"
                        slot="prepend"
                      >
                        <feather type="x" class="text-danger"></feather>
                      </a>
                      <a
                        @click="createdUserFind(field)"
                        slot="append"
                        type=""
                        class="btn"
                      >
                        Хайх
                      </a>
                    </Input>
                  </FormItem>
                </template>
                <template v-else-if="field.flag === 76">
                  <FormItem
                    :prop="field.field"
                    :label="field.title"
                    :key="`lbl_${i}`"
                    :rules="field.rule"
                  >
                    <DatePicker
                      v-model="$data['taskModel'][field.field]"
                      placeholder="Огноо сонгоно уу"
                      type="date"
                      :format="'yyyy-MM-dd'"
                      :value-format="'yyyy-MM-dd'"
                      style="width: 100%"
                    ></DatePicker>
                    <div class="text-muted tx-11 eddt-title-info">
                      {{ infoBuilder(field.info) }}
                    </div>
                  </FormItem>
                </template>
                <template v-else-if="field.flag === 81">
                  <FormItem
                    :rules="field.rule"
                    :prop="field.field"
                    :label="field.title"
                    :key="`lbl_${i}`"
                  >
                    <DatePicker
                      v-model="$data['taskModel'][field.field]"
                      type="month"
                      placeholder="Select date"
                      style="width: 100%"
                      :format="'yyyy-MM'"
                      :value-format="'yyyy-MM'"
                    ></DatePicker>
                    <div class="text-muted tx-11 eddt-title-info">
                      {{ infoBuilder(field.info) }}
                    </div>
                  </FormItem>
                </template>
                <template v-else-if="field.flag === 82">
                  <FormItem
                    :key="`cscrdassigntsk_${i}`"
                    :rules="field.rule"
                    :prop="field.field"
                    :label="field.title"
                  >
                    <loc-type-cascader-assign-task-other
                      :id="$data['taskModel'][field.field]"
                      :txt="$data['taskModel'][field.key.split(':')[1]]"
                      v-model="$data['taskModel'][field.field]"
                      :getParentType="true"
                      :locTypekey="field.key"
                      :otherTxt="field.info"
                      @loctype-selected="locTypeAssignTaskOther"
                    />
                    <!--  -->
                  </FormItem>
                </template>

                <template v-else-if="field.flag === 83">
                  <FormItem
                    :rules="field.rule"
                    :prop="field.field"
                    :label="field.title"
                    :key="`lbl_${i}`"
                  >
                    <vet-client-user-org-selecter
                      :selectedId="$data['taskModel'][field.field]"
                      v-model="$data['taskModel'][field.field]"
                    ></vet-client-user-org-selecter>
                  </FormItem>
                </template>
                <template v-else-if="field.flag === 85">
                  <FormItem
                    :rules="field.rule"
                    :prop="field.field"
                    :label="field.title"
                    :key="`lbl_${i}`"
                  >
                    <task-finder
                      v-model="$data['taskModel'][field.field]"
                      :selectedId="$data['taskModel'][field.field]"
                      @on-task-selected="field.cstmFld2 = $event.task"
                      :objectTypeId.sync="[field.key][0]"
                      :key="`tsk_${i}`"
                    ></task-finder>
                    <div class="text-muted tx-11 eddt-title-info">
                      {{ infoBuilder(field.info) }}
                    </div>
                  </FormItem>
                </template>
                <template v-else-if="field.flag === 87">
                  <FormItem
                    :rules="field.rule"
                    :prop="field.field"
                    :label="field.title"
                    :key="`lbl_${i}`"
                  >
                    <task-finder
                      v-model="$data['taskModel'][field.field]"
                      :selectedId="$data['taskModel'][field.field]"
                      @on-task-selected="
                        field.cstmFld2 = $event.task;
                        $data['taskModel']['task'] = $event.task;
                      "
                      :objectTypeId.sync="[field.key][0]"
                      :key="`tsk_${i}`"
                    ></task-finder>
                    <div class="text-muted tx-11 eddt-title-info">
                      {{ infoBuilder(field.info) }}
                    </div>
                  </FormItem>
                </template>
                <template v-else-if="field.flag === 88">
                  <FormItem
                    :rules="field.rule"
                    :prop="field.field"
                    :label="field.title"
                    :key="`lbl_${i}`"
                    style="position: relatove"
                  >
                    <div
                      v-if="
                        prms.parentTask != undefined &&
                          $data['taskModel'][field.field] == null
                      "
                    >
                      <span style="display: none">{{
                        ($data["taskModel"][field.field] =
                          prms.parentTask.organizationTaskId)
                      }}</span>
                    </div>
                    <task-finder
                      v-model="$data['taskModel'][field.field]"
                      :selectedId="$data['taskModel'][field.field]"
                      @on-task-selected="field.cstmFld2 = $event.task"
                      :objectTypeId.sync="[field.key][0]"
                      :key="`tsk_${i}`"
                    ></task-finder>
                    <!-- <div
                                  class="btn btn-danger"
                                  @click.prevent.stop="$data['taskModel'][field.field]=null; $data['taskModel'][field.key]=''"
                                >
                                  
                        </div>-->

                    <div class="text-muted tx-11 eddt-title-info">
                      {{ infoBuilder(field.info) }}
                    </div>
                  </FormItem>
                </template>
                <template v-else-if="field.flag === 90">
                  <FormItem
                    :rules="field.rule"
                    :prop="field.field"
                    :label="field.title"
                    :key="`lbl_${i}`"
                  >
                    <access-finder
                      :selected="$data['taskModel'][field.field]"
                      v-model="$data['taskModel'][field.field]"
                    />
                    <div class="text-muted tx-11 eddt-title-info">
                      {{ infoBuilder(field.info) }}
                    </div>
                  </FormItem>
                </template>
                <template v-else-if="field.flag === 91">
                  <FormItem
                    :rules="field.rule"
                    :prop="field.field"
                    :label="field.title"
                    :key="`lbl_${i}`"
                  >
                    {{ $data["taskModel"]["lat"] }}
                    <GmapMap
                      :center="{
                        lat:
                          $data['taskModel']['lat'] != null
                            ? parseFloat($data['taskModel']['lat'])
                            : 47.9138932,
                        lng:
                          $data['taskModel']['lng'] != null
                            ? parseFloat($data['taskModel']['lng'])
                            : 106.8986408,
                      }"
                      :zoom="13"
                      map-type-id="satellite"
                      style="width: 100%; height: 300px"
                      @click="createMapMarker"
                    >
                      <GmapMarker
                        v-for="(m, i) in googleMapMaker"
                        :key="i"
                        :position="m.position"
                      />
                    </GmapMap>
                  </FormItem>
                </template>
                <template v-else-if="field.flag === 92">
                  <FormItem
                    :key="`lbl_${i}`"
                    :rules="field.rule"
                    :prop="field.field"
                    :label="`${field.sectionId}.${i + 1} ${field.title}`"
                    class="m-b-xs"
                  >
                    <Select
                      v-model="$data['taskModel'][field.field]"
                      filterable
                      clearable
                      @change="timeCalcMethodChanged"
                    >
                      <Option
                        :value="0"
                        :label="'Бүх хэрэглэгч тохируулсан хугацаагаар'"
                        >Бүх хэрэглэгч тохируулсан хугацаагаар</Option
                      >
                      <Option
                        :value="9"
                        :label="'Эхлүүлсэн өдрөөс хэрэглэгч тус бүрээр'"
                        >Эхлүүлсэн өдрөөс хэрэглэгч тус бүрээр</Option
                      >
                    </Select>
                    <div
                      class="text-muted tx-11 eddt-title-info"
                      v-if="field.info != null && field.info != ''"
                    >
                      {{ infoBuilder(field.info) }}
                    </div>
                  </FormItem>
                </template>
                <template v-else-if="field.flag === 93">
                  <FormItem
                    :key="`lbl_${i}`"
                    :rules="field.rule"
                    :prop="field.field"
                    :label="field.title"
                    class="m-b-xs"
                  >
                    <span class="tx-info" v-show="taskModel.i1 == 1"
                      >баталгаажсан</span
                    >
                    <span class="tx-warning" v-show="taskModel.i1 == 0"
                      >шинэ</span
                    >
                    <span v-show="taskModel.i1 == 2" class="tx-success"
                      >буцаан авсан</span
                    >
                    <span class="tx-danger" v-show="taskModel.i1 == -1"
                      >цуцалсан</span
                    >
                    захиалга
                    <div class="text-muted tx-11 eddt-title-info">
                      {{ infoBuilder(field.info) }}
                    </div>
                  </FormItem>
                </template>
                <template v-else-if="field.flag === 94">
                  <FormItem
                    :key="`lbl_${i}`"
                    :rules="field.rule"
                    :prop="field.field"
                    :label="field.title"
                  >
                    <loctype-multiple-tag
                      v-model="$data['taskModel'][field.field]"
                      :ids.sync="$data['taskModel'][field.field]"
                      :lkey="getProjId(field.key)"
                    ></loctype-multiple-tag>
                    <div class="text-muted tx-11 eddt-title-info">
                      {{ infoBuilder(field.info) }}
                    </div>
                  </FormItem>
                </template>
                <template v-else-if="field.flag === 95">
                  <FormItem
                    :rules="field.rule"
                    :prop="field.field"
                    :label="field.title"
                    :key="`lbl_${i}`"
                  >
                    <div
                      v-if="
                        prms.parentTask != undefined &&
                          $data['taskModel'][field.field] == null
                      "
                    >
                      <span style="display: none">{{
                        ($data["taskModel"][field.field] =
                          prms.parentTask.secondOrganizationTaskId)
                      }}</span>
                    </div>
                    <task-finder
                      v-model="$data['taskModel'][field.field]"
                      :selectedId="$data['taskModel'][field.field]"
                      @on-task-selected="field.cstmFld2 = $event.task"
                      :objectTypeId.sync="[field.key][0]"
                      :key="`tsk_${i}`"
                    ></task-finder>
                    <div class="text-muted tx-11 eddt-title-info">
                      {{ infoBuilder(field.info) }}
                    </div>
                  </FormItem>
                </template>
                <template v-else-if="field.flag === 96">
                  <FormItem
                    :rules="field.rule"
                    :prop="field.field"
                    :label="field.title"
                    :key="`lbl_${i}`"
                  >
                    <div
                      v-if="
                        prms.parentTask != undefined &&
                          $data['taskModel'][field.field] == null
                      "
                    >
                      <span style="display: none">{{
                        ($data["taskModel"][field.field] =
                          prms.parentTask.thirdOrganizationTaskId)
                      }}</span>
                    </div>
                    <task-finder
                      v-model="$data['taskModel'][field.field]"
                      :selectedId="$data['taskModel'][field.field]"
                      @on-task-selected="field.cstmFld2 = $event.task"
                      :objectTypeId.sync="[field.key][0]"
                      :key="`tsk_${i}`"
                    ></task-finder>
                    <div class="text-muted tx-11 eddt-title-info">
                      {{ infoBuilder(field.info) }}
                    </div>
                  </FormItem>
                </template>
                <template v-else-if="field.flag === 97">
                  <FormItem
                    :rules="field.rule"
                    :prop="field.field"
                    :label="field.title"
                    :key="`lbl_${i}`"
                  >
                    <div
                      v-if="
                        prms.parentTask != undefined &&
                          $data['taskModel'][field.field] == null
                      "
                    >
                      <span style="display: none">{{
                        ($data["taskModel"][field.field] =
                          prms.parentTask.fourthOrganizationTaskId)
                      }}</span>
                    </div>
                    <task-finder
                      v-model="$data['taskModel'][field.field]"
                      :selectedId="$data['taskModel'][field.field]"
                      @on-task-selected="field.cstmFld2 = $event.task"
                      :objectTypeId.sync="[field.key][0]"
                      :key="`tsk_${i}`"
                    ></task-finder>
                    <div class="text-muted tx-11 eddt-title-info">
                      {{ infoBuilder(field.info) }}
                    </div>
                  </FormItem>
                </template>
                <template v-else-if="field.flag == 98">
                  <!-- {{$data['taskModel'][field.field] != null? false :true}}
                      {{$data['taskModel'][field.field]}}
                      {{prms.parentTask}}
                      {{taskModel.parentTask}} -->
                  <FormItem
                    :key="`lbl_${i}`"
                    :rules="field.rule"
                    :prop="field.field"
                    :label="field.title"
                  >
                    <!-- :disabled="($data['taskModel'][field.field] != null && taskModel.id!=0) ? true : false" -->
                    <!-- :parentFilterable="$data['taskModel'][field.field] != null? false :true" -->
                    <!-- :parentId="$data['taskModel'][field.field] != null? 0 : ( prms.parentTask!=undefined && prms.parentTask!=null ? prms.parentTask.locTypeId : 0)" -->
                    <!-- :checkStrictly="$data['taskModel'][field.field] != null ? true: false" -->
                    
                    <loc-type-cascader
                      :id.sync="$data['taskModel'][field.field]"
                      v-model="$data['taskModel'][field.field]"
                      :getParentType="true"
                      :anyLevel="true"
                      :checkStrictly="false"
                      :parentFilterable="true"
                      :parentId="
                        taskModel.id == 0
                          ? prms.parentTask != undefined &&
                            prms.parentTask != null
                            ? prms.parentTask.locTypeId
                            : 0
                          : taskModel.parentTask != null
                          ? taskModel.parentTask.locTypeId
                          : 0
                      "
                      :locTypekey.sync="field.key"
                      @loctype-selected_withdata="
                        taskModel.taskEn =
                          (prms.parentTask != undefined &&
                          prms.parentTask != null &&
                          prms.parentTask.taskEn != undefined
                            ? prms.parentTask.taskEn
                            : '') + $event.data.code;
                        taskModel.id == 0
                          ? (taskModel.task = $event.data.label)
                          : '';
                      "
                    />
                    <div class="text-muted tx-11 eddt-title-info">
                      {{ infoBuilder(field.info) }}
                    </div>
                  </FormItem>
                </template>
                <template v-else-if="field.flag === 100">
                  <FormItem
                    v-if="taskModel.id == 0"
                    :rules="field.rule"
                    :label="field.title"
                    :prop="field.field"
                    :key="`lbl_${i}`"
                  >
                    <Input
                      v-if="field.maxlength > 0"
                      :placeholder="field.info"
                      v-model="$data['taskModel'][field.field]"
                      :maxlength="field.maxlength"
                    />
                    <Input
                      v-else
                      :placeholder="field.info"
                      v-model="$data['taskModel'][field.field]"
                    />
                  </FormItem>
                </template>
                <template v-else-if="field.flag === 101">
                  <FormItem
                    :label="field.title"
                    :prop="field.field"
                    :key="`lbl_${i}`"
                  >
                    <Select
                      v-model="$data['taskModel'][field.field]"
                      filterable
                      clearable
                      class="wd-100p"
                    >
                      <Option :value="0" label="Цахим"></Option>
                      <Option :value="1" label="Биет"></Option>
                      <!-- <Option :value="2" label="Цаасан & Цахим"></Option> -->
                      <!-- tsesend gargasan uchir davhart hailt hiih bolomjgui bolood hasav -->
                    </Select>
                  </FormItem>
                </template>
                <template v-else-if="field.flag === 102">
                  <FormItem
                    :label="field.title"
                    :prop="field.field"
                    :key="`lbl_${i}`"
                  >
                    <Select
                      v-model="$data['taskModel'][field.field]"
                      filterable
                      clearable
                      class="wd-100p"
                    >
                      <!-- <Option
                            :value="0"
                            label="Вэб апп-р нэээгдэх"
                          ></Option> -->
                      <Option
                        :value="1"
                        label="Десктоп апп-р нэээгдэх"
                      ></Option>
                      <!-- <Option
                            :value="2"
                            label="Багш вэб апп-р, Сурагч десктоп апп-р нэээгдэх"
                          ></Option> -->
                    </Select>
                  </FormItem>
                </template>
                <template v-else-if="field.flag === 103">
                  <FormItem
                    :label="field.title"
                    :prop="field.field"
                    :key="`lbl_${i}`"
                  >
                    {{ $data["taskModel"][field.field] }}
                    <div style="overflow-x: auto">
                      <template v-if="taskModel.objectTypeId == 508">
                        <spec-asset-chooser
                          @on-asset-changed="assetChanged"
                          :locationId="
                            taskModel.id == 0
                              ? prms.parentTask != null
                                ? prms.parentTask.organizationTaskId
                                : $data['taskModel']['organizationTaskId']
                              : $data['taskModel']['organizationTaskId']
                          "
                          :assetId="
                            taskModel.id == 0
                              ? prms.parentTask != null
                                ? prms.parentTask.secondOrganizationTaskId
                                : $data['taskModel']['secondOrganizationTaskId']
                              : $data['taskModel']['secondOrganizationTaskId']
                          "
                          :mode="2"
                        ></spec-asset-chooser>
                      </template>
                      <template v-else>
                        <spec-asset-chooser
                          @on-asset-changed="assetChanged"
                          :locationId="$data['taskModel']['organizationTaskId']"
                          :assetId="
                            $data['taskModel']['secondOrganizationTaskId']
                          "
                          :mode="1"
                        ></spec-asset-chooser>
                      </template>
                    </div>
                  </FormItem>
                </template>
                <template v-else-if="field.flag === 104">
                  <FormItem
                    :rules="field.rule"
                    :prop="field.field"
                    :label="field.title"
                    :key="`lbl_${i}`"
                  >
                    <div slot="label">
                      {{ field.sectionId }}.{{ i + 1 }} {{ field.title }}
                      <Popover
                        :key="`lbl_info_${i}`"
                        placement="top-start"
                        title="Тайлбар"
                        width="400"
                        trigger="hover"
                        :open-delay="200"
                        :content="infoBuilder(field.info)"
                      >
                        <i
                          v-if="field.info != null && field.info != ''"
                          slot="reference"
                          circle
                          class="el-icon-question"
                          type="info"
                        ></i>
                      </Popover>
                    </div>
                    <div
                      v-if="
                        prms.parentTask != undefined &&
                          $data['taskModel'][field.field] == null
                      "
                    >
                      <span style="display: none">{{
                        ($data["taskModel"][field.field] =
                          prms.parentTask.fifthOrganizationTaskId)
                      }}</span>
                    </div>
                    <task-finder
                      v-model="$data['taskModel'][field.field]"
                      :selectedId="$data['taskModel'][field.field]"
                      @on-task-selected="field.cstmFld2 = $event.task"
                      :objectTypeId.sync="[field.key][0]"
                      :key="`tsk_${i}`"
                    ></task-finder>
                    <!-- <div class="text-muted tx-11 eddt-title-info">
                      {{ infoBuilder(field.info) }}
                    </div> -->
                  </FormItem>
                </template>
                <template v-else-if="field.flag == 105">
                  <FormItem
                    :key="`lbl_${i}`"
                    :rules="field.rule"
                    :prop="field.field"
                    :label="field.title"
                  >
                    <div slot="label">
                      {{ field.sectionId }}.{{ i + 1 }} {{ field.title }}
                      <Popover
                        :key="`lbl_info_${i}`"
                        placement="top-start"
                        title="Тайлбар"
                        width="400"
                        trigger="hover"
                        :open-delay="200"
                        :content="infoBuilder(field.info)"
                      >
                        <i
                          v-if="field.info != null && field.info != ''"
                          slot="reference"
                          circle
                          class="el-icon-question"
                          type="info"
                        ></i>
                      </Popover>
                    </div>
                    <loc-type-radio
                      @valueChanged="radioValueChanged(field.field, $event)"
                      :id.sync="$data['taskModel'][field.field]"
                      v-model="$data['taskModel'][field.field]"
                      :getParentType="true"
                      :locTypekey.sync="field.key"
                      :disabled="
                        taskModel.objectTypeId == 411 && taskModel.id != 0
                      "
                    />
                    <!-- <div class="text-muted tx-11 eddt-title-info">
                      {{ infoBuilder(field.info) }}
                    </div> -->
                  </FormItem>
                </template>
                <template v-else-if="field.flag == 106">
                  <FormItem
                    :key="`lbl_${i}`"
                    :rules="field.rule"
                    :prop="field.field"
                    :label="field.title"
                  >
                    <spec-asset-list-chooser
                      v-model="$data['taskModel'][field.field]"
                      :typeId="field.key"
                      :selectedValue="$data['taskModel'][field.field]"
                    ></spec-asset-list-chooser>
                    <div class="text-muted tx-11 eddt-title-info">
                      {{ infoBuilder(field.info) }}
                    </div>
                  </FormItem>
                </template>
                <template v-else-if="field.flag == 107">
                  <FormItem
                    :key="`lbl_${i}`"
                    :rules="field.rule"
                    :prop="field.field"
                    :label="field.title"
                  >
                    <!-- {{$route.params}} -->
                    {{
                      ($data.taskModel.task =
                        $store.state.user.userInfo.fullName)
                    }}
                    <span style="display:none">
                      {{
                        ($data.taskModel.i1 = new Date(
                          $data.taskModel.createdDate
                        ).getFullYear())
                      }}
                      {{
                        ($data.taskModel.locTypeId = parseInt(
                          $route.params.locTypeId,
                          10
                        ))
                      }}
                    </span>
                  </FormItem>
                </template>
                <template v-else-if="field.flag === 108">
                  <FormItem
                    v-if="prms.boxId != undefined && prms.boxId > 0"
                    :rules="field.rule"
                    :prop="field.field"
                    :label="field.title"
                    :key="`lbl_${i}`"
                  >
                    <div slot="label">
                      {{ field.sectionId }}.{{ i + 1 }} {{ field.title }}
                      <Popover
                        :key="`lbl_info_${i}`"
                        placement="top-start"
                        title="Тайлбар"
                        width="400"
                        trigger="hover"
                        :open-delay="200"
                        :content="infoBuilder(field.info)"
                      >
                        <i
                          v-if="field.info != null && field.info != ''"
                          slot="reference"
                          circle
                          class="el-icon-question"
                          type="info"
                        ></i>
                      </Popover>
                    </div>
                    <div
                      v-if="
                        prms.parentTask != undefined &&
                          $data['taskModel'][field.field] == null
                      "
                    >
                      <span style="display: none">{{
                        ($data["taskModel"][field.field] = prms.parentTask.id)
                      }}</span>
                    </div>
                    <task-finder
                      v-model="$data['taskModel'][field.field]"
                      :selectedId="$data['taskModel'][field.field]"
                      @on-task-selected="field.cstmFld2 = $event.task"
                      :objectTypeId.sync="[field.key][0]"
                      :key="`tsk_${i}`"
                    ></task-finder>
                    <!-- <div class="text-muted tx-11 eddt-title-info">
                      {{ infoBuilder(field.info) }}
                    </div> -->
                  </FormItem>
                </template>
                <template v-else-if="field.flag == 109">
                  <div
                    :key="`bx109_${i}`"
                    v-if="prms.boxId != undefined && prms.boxId > 0"
                  ></div>
                  <FormItem
                    v-else
                    :key="`lbl_${i}`"
                    :rules="field.rule"
                    :prop="field.field"
                    :label="field.title"
                  >
                    <div slot="label">
                      {{ field.sectionId }}.{{ i + 1 }} {{ field.title }}
                      <Popover
                        :key="`lbl_info_${i}`"
                        placement="top-start"
                        title="Тайлбар"
                        width="400"
                        trigger="hover"
                        :open-delay="200"
                      >
                        <div v-html="infoBuilder(field.info)"></div>
                        <i
                          v-if="field.info != null && field.info != ''"
                          slot="reference"
                          circle
                          class="el-icon-question"
                          type="info"
                        ></i>
                      </Popover>
                    </div>
                    <!-- || taskModel.objectTypeId == 533 -->
                    <loc-type-cascader
                      :id.sync="$data['taskModel'][field.field]"
                      v-model="$data['taskModel'][field.field]"
                      :getParentType="true"
                      :locTypekey.sync="field.key"
                      :disabled="
                        (taskModel.objectTypeId == 411 && taskModel.id != 0) ||
                          taskModel.objectTypeId == 533
                      "
                    />
                    <!-- <div class="text-muted tx-11 eddt-title-info">
                      {{ infoBuilder(field.info) }}
                    </div> -->
                  </FormItem>
                </template>
                <template v-else-if="field.flag === 110">
                  <div
                    :key="`bx110_${i}`"
                    v-if="prms.boxId != undefined && prms.boxId > 0"
                  ></div>
                  <FormItem
                    v-else
                    :rules="field.rule"
                    :prop="field.field"
                    :label="field.title"
                    :key="`lbl_${i}`"
                  >
                    <div slot="label">
                      {{ field.sectionId }}.{{ i + 1 }} {{ field.title }}
                      <Popover
                        :key="`lbl_info_${i}`"
                        placement="top-start"
                        title="Тайлбар"
                        width="400"
                        trigger="hover"
                        :open-delay="200"
                        :content="infoBuilder(field.info)"
                      >
                        <i
                          v-if="field.info != null && field.info != ''"
                          slot="reference"
                          circle
                          class="el-icon-question"
                          type="info"
                        ></i>
                      </Popover>
                    </div>
                    <task-finder
                      v-model="$data['taskModel'][field.field]"
                      :selectedId="$data['taskModel'][field.field]"
                      @on-task-selected="field.cstmFld2 = $event.task"
                      :objectTypeId.sync="[field.key][0]"
                      :key="`tsk_${i}`"
                    ></task-finder>
                    <!-- <div class="text-muted tx-11 eddt-title-info">
                      {{ infoBuilder(field.info) }}
                    </div> -->
                  </FormItem>
                </template>
                <template v-else-if="field.flag === 111">
                  <div
                    :key="`dvd_${i}`"
                    v-if="prms.boxId != undefined && prms.boxId > 0"
                  ></div>
                  <Divider v-else :key="`dvdr${i}`">{{ field.title }}</Divider>
                </template>
                <template v-else-if="field.flag === 112">
                  <div
                    :key="`bx_${i}`"
                    v-if="prms.boxId != undefined && prms.boxId > 0"
                  ></div>
                  <FormItem
                    v-else
                    :prop="field.field"
                    :label="field.title"
                    :key="`lbl_${i}`"
                    :rules="field.rule"
                  >
                    <div slot="label">
                      {{ field.sectionId }}.{{ i + 1 }} {{ field.title }}
                      <Popover
                        :key="`lbl_info_${i}`"
                        placement="top-start"
                        title="Тайлбар"
                        width="400"
                        trigger="hover"
                        :open-delay="200"
                        :content="infoBuilder(field.info)"
                      >
                        <i
                          v-if="field.info != null && field.info != ''"
                          slot="reference"
                          circle
                          class="el-icon-question"
                          type="info"
                        ></i>
                      </Popover>
                    </div>
                    <VueCtkDateTimePicker
                      locale="mn"
                      v-model="$data['taskModel'][field.field]"
                      no-label
                      format="YYYY-MM-DD HH:mm"
                    />
                    <!-- <div class="text-muted tx-11 eddt-title-info">
                      {{ infoBuilder(field.info) }}
                    </div> -->
                  </FormItem>
                </template>
                <template v-else-if="field.flag === 113">
                  <div
                    :key="`bx113_${i}`"
                    v-if="prms.boxId != undefined && prms.boxId > 0"
                  ></div>
                  <FormItem
                    v-else
                    :rules="field.rule"
                    :label="field.title"
                    :prop="field.field"
                    :key="`lbl_${i}`"
                  >
                    <Input
                      v-if="field.maxlength > 0"
                      :placeholder="field.info"
                      v-model="$data['taskModel'][field.field]"
                      :maxlength="field.maxlength"
                    />
                    <Input
                      v-else
                      :placeholder="field.info"
                      v-model="$data['taskModel'][field.field]"
                    />
                  </FormItem>
                </template>
                <template v-else-if="field.flag === 114">
                  <FormItem
                    :rules="field.rule"
                    :prop="field.field"
                    :label="field.title"
                    :key="`lbl_${i}`"
                  >
                    <div slot="label">
                      {{ field.sectionId }}.{{ i + 1 }} {{ field.title }}
                      <Popover
                        :key="`lbl_info_${i}`"
                        placement="top-start"
                        title="Тайлбар"
                        width="400"
                        trigger="hover"
                        :open-delay="200"
                        :content="infoBuilder(field.info)"
                      >
                        <i
                          v-if="field.info != null && field.info != ''"
                          slot="reference"
                          circle
                          class="el-icon-question"
                          type="info"
                        ></i>
                      </Popover>
                    </div>
                    <div class="d-flex">
                      <depart-cascader2
                        :pid="parseInt(field.key)"
                        :checkStrictly="false"
                        :id="$data['taskModel'][field.field]"
                        :id2="$data['taskModel']['departId2']"
                        v-model="$data['taskModel'][field.field]"
                        @on-change-2="departCascader2Changed(field.key, $event)"
                      />
                    </div>
                    <!-- {{ $data['taskModel'][field.field] }}
                          {{ $data['taskModel']['departId2'] }} -->
                    <!-- <div class="text-muted tx-11 eddt-title-info">
                      {{ infoBuilder(field.info) }}
                    </div> -->
                  </FormItem>
                </template>
                <template v-else-if="field.flag === 115">
                  <FormItem
                    :rules="field.rule"
                    :prop="field.field"
                    :label="field.title"
                    :key="`lbl_${i}`"
                  >
                    <div slot="label">
                      {{ field.sectionId }}.{{ i + 1 }} {{ field.title }}
                      <Popover
                        :key="`lbl_info_${i}`"
                        placement="top-start"
                        title="Тайлбар"
                        width="400"
                        trigger="hover"
                        :open-delay="200"
                        :content="infoBuilder(field.info)"
                      >
                        <i
                          v-if="field.info != null && field.info != ''"
                          slot="reference"
                          circle
                          class="el-icon-question"
                          type="info"
                        ></i>
                      </Popover>
                    </div>
                    <div class="d-flex" style="overflow: auto">
                      <loc-type-panel
                        v-model="$data['taskModel'][field.field]"
                        :ids.sync="$data['taskModel'][field.field]"
                        :lkey.sync="field.key"
                        :titl="field.title"
                        @on-selected="locTypePanelOnChange"
                      ></loc-type-panel>
                      <!-- {{$data['taskModel'][field.field]}} -->
                    </div>
                    <!-- <div class="text-muted tx-11 eddt-title-info">
                      {{ infoBuilder(field.info) }}
                    </div> -->
                  </FormItem>
                </template>

                <template v-else-if="field.flag === 116">
                  <FormItem
                    :rules="field.rule"
                    :prop="field.field"
                    :label="field.title"
                    :key="`lbl_${i}`"
                  >
                    <div slot="label">
                      {{ field.sectionId }}.{{ i + 1 }} {{ field.title }}
                      <Popover
                        :key="`lbl_info_${i}`"
                        placement="top-start"
                        title="Тайлбар"
                        width="400"
                        trigger="hover"
                        :open-delay="200"
                        :content="infoBuilder(field.info)"
                      >
                        <i
                          v-if="field.info != null && field.info != ''"
                          slot="reference"
                          circle
                          class="el-icon-question"
                          type="info"
                        ></i>
                      </Popover>
                    </div>
                    <task-finder-simple
                      v-model="$data['taskModel'][field.field]"
                      :selectedId="$data['taskModel'][field.field]"
                      @on-task-selected="onTaskSelectedSimple(field, $event)"
                      :objectTypeId.sync="[field.key][0]"
                      :fieldName="field.field"
                      :fld="field"
                      :prmsProp="prms"
                      :key="`tsk_${i}`"
                    ></task-finder-simple>
                    <!-- <div class="text-muted tx-11 eddt-title-info">
                      {{ infoBuilder(field.info) }}
                    </div> -->
                  </FormItem>
                </template>

                <template v-else-if="field.flag == 88888">
                  <div
                    :key="`aaahidd${i}`"
                    role="button"
                    class="pd-10 rounded mg-b-20"
                    @click="hiddenFields = !hiddenFields"
                    style="background-color: rgb(255, 243, 223)"
                  >
                    <div class="d-flex align-items-center">
                      <div class="bg-warning pd-5 rounded">
                        <feather type="sliders"></feather>
                      </div>
                      <div
                        class="
                              mg-l-auto
                              tx-uppercase
                              tx-11
                              tx-spacing-1
                              tx-color-02
                              tx-semibold
                            "
                      >
                        нэмэлт мэдээлэл оруулах
                      </div>
                      <div class="mg-l-auto">
                        <feather
                          v-if="hiddenFields"
                          type="chevron-up"
                        ></feather>
                        <feather v-else type="chevron-down"></feather>
                      </div>
                    </div>
                  </div>
                </template>

                <template v-else-if="field.flag === 11501">
                  <FormItem
                    v-if="fieldShowCheck(field.field)"
                    :key="`lbl_${i}`"
                    :rules="field.rule"
                    :prop="field.field"
                    :label="`${field.sectionId}.${i + 1} ${field.title}`"
                  >
                    <div slot="label">
                      {{ field.sectionId }}.{{ i + 1 }} {{ field.title }}
                      <Popover
                        :key="`lbl_info_${i}`"
                        placement="top-start"
                        title="Тайлбар"
                        width="400"
                        trigger="hover"
                        :open-delay="200"
                        :content="infoBuilder(field.info)"
                      >
                        <i
                          v-if="field.info != null && field.info != ''"
                          slot="reference"
                          circle
                          class="el-icon-question"
                          type="info"
                        ></i>
                      </Popover>
                    </div>
                    <RadioGroup
                      v-model="$data['taskModel'][field.field]"
                      @change="yesNoBoolChanged(field, $event)"
                    >
                      <Radio :label="true">
                        <span>Тийм</span>
                      </Radio>
                      <Radio :label="false">
                        <span>Үгүй</span>
                      </Radio>
                    </RadioGroup>
                    <!-- <div
                      v-if="field.info != null && field.info != ''"
                      class="text-muted tx-11 eddt-title-info"
                    >
                      {{ infoBuilder(field.info) }}
                    </div> -->
                  </FormItem>
                </template>
                <template v-else-if="field.flag === 11502">
                  <FormItem
                    v-if="fieldShowCheck(field.field)"
                    :key="`lbl_${i}`"
                    :rules="field.rule"
                    :prop="field.field"
                    :label="`${field.sectionId}.${i + 1} ${field.title}`"
                  >
                    <div slot="label">
                      {{ field.sectionId }}.{{ i + 1 }} {{ field.title }}
                      <Popover
                        :key="`lbl_info_${i}`"
                        placement="top-start"
                        title="Тайлбар"
                        width="400"
                        trigger="hover"
                        :open-delay="200"
                        :content="infoBuilder(field.info)"
                      >
                        <i
                          v-if="field.info != null && field.info != ''"
                          slot="reference"
                          circle
                          class="el-icon-question"
                          type="info"
                        ></i>
                      </Popover>
                    </div>
                    <RadioGroup v-model="$data['taskModel'][field.field]">
                      <Radio :label="0">
                        <span>Тийм</span>
                      </Radio>
                      <Radio :label="1">
                        <span>Шаардлагагүй</span>
                      </Radio>
                    </RadioGroup>
                    <!-- <div
                      v-if="field.info != null && field.info != ''"
                      class="text-muted tx-11 eddt-title-info"
                    >
                      {{ infoBuilder(field.info) }}
                    </div> -->
                  </FormItem>
                </template>
                <template v-else-if="field.flag === 11503">
                  <FormItem
                    v-if="fieldShowCheck(field.field)"
                    :key="`lbl_${i}`"
                    :rules="field.rule"
                    :prop="field.field"
                    :label="`${field.sectionId}.${i + 1} ${field.title}`"
                  >
                    <div slot="label">
                      {{ field.sectionId }}.{{ i + 1 }} {{ field.title }}
                      <Popover
                        :key="`lbl_info_${i}`"
                        placement="top-start"
                        title="Тайлбар"
                        width="400"
                        trigger="hover"
                        :open-delay="200"
                        :content="infoBuilder(field.info)"
                      >
                        <i
                          v-if="field.info != null && field.info != ''"
                          slot="reference"
                          circle
                          class="el-icon-question"
                          type="info"
                        ></i>
                      </Popover>
                    </div>
                    <RadioGroup
                      v-model="$data['taskModel'][field.field]"
                      @change="yesNoIntChanged(field, $event)"
                    >
                      <Radio :label="1">
                        <span>Тийм</span>
                      </Radio>
                      <Radio :label="0">
                        <span>Үгүй</span>
                      </Radio>
                    </RadioGroup>
                    <!-- <div
                      v-if="field.info != null && field.info != ''"
                      class="text-muted tx-11 eddt-title-info"
                    >
                      {{ infoBuilder(field.info) }}
                    </div> -->
                  </FormItem>
                </template>
                <template v-else-if="field.flag === 11504">
                  <!-- {{$data['taskModel']['flag']}} -->
                  <div :key="`bx11504_${i}`" class="mg-t-20 mg-b-5">
                    {{ field.sectionId }}.{{ i + 1 }}.
                    {{
                      $data["taskModel"]["flag"] == 0
                        ? "Бүх хэрэглэгч доор тохируулсан хугацаанд сургалтыг үзэж дуусгана"
                        : "Сургалтын идэвхтэй байх хугацаа"
                    }}
                  </div>
                </template>
                <template v-else>
                  <div class="text-right" :key="`ddr${i}`">
                    {{ field.flag }}
                  </div>
                </template>
              </template>
            </Form>
          </div>
        </div>
        <template v-slot:footer>
          <div
            class="ht-55 bd-t d-flex align-items-center justify-content-center pd-x-15"
          >
            <!-- <div v-if="activeSection==3" class="btn-group">
                  <a @click="onSubmit()" class="btn btn-white btn-uppercase flex-fill">Хадгалах</a>
                  <a v-if="taskDetail.isPublic" @click="onSubmit({isPublic:false})" class="btn btn-warning btn-uppercase flex-fill">Нийтлэхгүй</a>
                  <a v-else @click="onSubmit({isPublic:true})" class="btn btn-success btn-uppercase flex-fill">Нийтлэх</a>
                </div>
                <div v-else>
                  <a @click="onSubmit()" class="btn btn-white btn-uppercase flex-fill">Хадгалах</a>
                </div> -->

            <div>
              <a
                @click="onSubmitConfirm()"
                class="btn btn-white btn-uppercase flex-fill"
                >Хадгалах</a
              >
            </div>
          </div>
        </template>
      </b-sidebar>
    </template>
  </div>
</template>
<script>
import { request } from "@/api/all";
import { hasOneOf } from "@/libs/tools";
var _ = require("lodash");
const moment = require("moment");

import AsyncLoadError from "@/components/base/asyncLoadingError";
import AsyncLoading from "@/components/base/asyncLoading";

import VueCtkDateTimePicker from "vue-ctk-date-time-picker";
import "vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css";

import loader from "@/components/box/loader/loader.vue";

import "element-ui/lib/theme-chalk/index.css";
import {
  Form,
  Input,
  FormItem,
  DatePicker,
  Divider,
  InputNumber,
  Select,
  OptionGroup,
  Option,
  Checkbox,
  RadioGroup,
  Radio,
  Notification,
  Tooltip,
  Button,
  Popover,
  MessageBox,
  Dialog,
} from "element-ui";

export default {
  name: "courseEdit",
  components: {
    VueCtkDateTimePicker,
    Form,
    FormItem,
    Input,
    DatePicker,
    Divider,
    InputNumber,
    Select,
    OptionGroup,
    Option,
    Checkbox,
    RadioGroup,
    Radio,
    Tooltip,
    Button,
    Popover,
    MessageBox,
    Dialog,
    loader,
    taskEdit: () => ({
      component: import("@/components/task/edit/base"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    accessFinder: () => ({
      component: import("@/components/task/edit/components/access"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    taskFinder: () => ({
      component: import("@/components/task/edit/components/taskFinder"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    taskFinderSimple: () => ({
      component: import("@/components/task/edit/components/taskFinderSimple"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    mediaFinder: () => ({
      component: import("@/components/modules/media/finder"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    vetClientUserOrgSelecter: () => ({
      component: import(
        "@/components/task/edit/components/vetClientUserOrgSelecter"
      ),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    crmUserDefaultCompanySelecter: () => ({
      component: import(
        "@/components/task/edit/components/crmUserDefaultCompanySelecter"
      ),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    locTypeCascader: () => ({
      component: import("@/components/task/edit/components/locTypeCascader"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    locTypeRadio: () => ({
      component: import("@/components/task/edit/components/locTypeRadio"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    locTypeCascaderAssignTaskOther: () => ({
      component: import(
        "@/components/task/edit/components/locTypeAssignTaskOther"
      ),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    locTypeCascaderAssignTask: () => ({
      component: import("@/components/task/edit/components/locTypeAssignTask"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    locTypeCascaderWithField: () => ({
      component: import("@/components/task/edit/components/locTypeWithField"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    loctypeMultipleTag: () => ({
      component: import("@/components/task/edit/components/locTypeMultipleTag"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    locTypePanel: () => ({
      component: import(
        "@/components/task/edit/components/locTypeMultiplePanel"
      ),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    simpleUploader: () => ({
      component: import("@/components/modules/media/simpleUploader.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    summernote: () => ({
      component: import("@/components/modules/editor/summernote"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    actionDialog: () => ({
      component: import("@/components/task/components/actions/dialog.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    hrmTagAssign: () => ({
      component: import("@/components/task/edit/components/hrmTagAssign"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    projectDropdown: () => ({
      component: import("@/components/project/components/dropdown.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    departCascader: () => ({
      component: import("@/components/modules/hr/departCascader"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    departCascader2: () => ({
      component: import("@/components/modules/hr/departCascader2"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    specAssetChooser: () => ({
      component: import(
        "@/components/task/edit/components/specials/asset/flatChooser"
      ),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    specAssetListChooser: () => ({
      component: import(
        "@/components/task/edit/components/specials/asset/listChooser"
      ),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
  },
  data() {
    var validateTrainingDays = (rule, value, callback) => {
      if (
        this.taskModel.flag == 9 &&
        (value < 1 || value == undefined || value == null)
      ) {
        callback(
          new Error("Элссэнээс хойш сургалтыг үзэж дуусгах өдрийн тоог оруулна")
        );
      } else {
        // if (this.ruleForm.checkPass !== "") {
        //   this.$refs.ruleForm.validateField("checkPass");
        // }
        callback();
      }
    };
    var validateCreditPoint = (rule, value, callback) => {
      if (
        this.taskModel.taskPinIs == true &&
        (value < 1 || value == undefined || value == null)
      ) {
        callback(new Error("Сургалтын оноо / Кредит оруулна уу."));
      } else {
        // if (this.ruleForm.checkPass !== "") {
        //   this.$refs.ruleForm.validateField("checkPass");
        // }
        callback();
      }
    };
    var validateMemberLimitCount = (rule, value, callback) => {
      if (
        this.taskModel.minutes == 1 &&
        (value < 1 || value == undefined || value == null)
      ) {
        callback(new Error("Анги дүүргэлтийн тоо оруулна уу."));
      } else {
        // if (this.ruleForm.checkPass !== "") {
        //   this.$refs.ruleForm.validateField("checkPass");
        // }
        callback();
      }
    };
    var validateBudget = (rule, value, callback) => {
      if (
        this.taskModel.qualityPercChanar == 1 &&
        (value < 1 || value == undefined || value == null)
      ) {
        callback(new Error("Сургалтын төлбөр тохируулна уу."));
      } else {
        // if (this.ruleForm.checkPass !== "") {
        //   this.$refs.ruleForm.validateField("checkPass");
        // }
        callback();
      }
    };
    var validateHasPayment = (rule, value, callback) => {
      if (value == 1 && this.taskModel.flagAccept == 1) {
        this.taskModel.qualityPercChanar = null;
        Notification({
          title: "Санамж",
          message:
            "Бүртгэл хэсгийн 3.2 тохиргоо зөвхөн үгүй үед төлбөртэй сургалт үүсгэх боломжтой.",
          type: "warning",
          duration: 10000,
        });
        callback(
          new Error(
            "Бүртгэл хэсгийн 3.2 тохиргоо зөвхөн үгүй үед төлбөртэй сургалт үүсгэх боломжтой."
          )
        );
      }
      if (this.taskModel.minutes == 0 && value == 1) {
        this.taskModel.qualityPercChanar = null;
        Notification({
          title: "Санамж",
          message:
            "Бүртгэл хэсгийн 3.1 тохиргоо зөвхөн тийм үед төлбөртэй сургалт үүсгэх боломжтой.",
          type: "warning",
          duration: 10000,
        });
        callback(
          new Error(
            "Бүртгэл хэсгийн 3.1 тохиргоо зөвхөн тийм үед төлбөртэй сургалт үүсгэх боломжтой."
          )
        );
      } else {
        callback();
      }
    };

    var validateDirectRegistration = (rule, value, callback) => {
      //alert("this first");
      if (this.taskModel.budget > 0 && value == 1) {
        //alert("this 1");
        this.taskModel.flagAccept = 0;
        Notification({
          title: "Санамж",
          message:
            "Төлбөртэй сургалтад шууд элсүүлэх тохиргоо хийх боломжгүй. Эхлээд сургалтаа төлбөргүй болгоно уу.",
          type: "warning",
          duration: 10000,
        });
        callback(
          new Error(
            "Төлбөртэй сургалтад шууд элсүүлэх тохиргоо хийх боломжгүй. Эхлээд сургалтаа төлбөргүй болгоно уу."
          )
        );
      } else {
        //alert("this 0");
        callback();
      }

      //if()
    };
    return {
      myLocKey: 0,
      taskId: 0,
      taskDetail: {},
      showSidebar: false,
      activeSection: 1,
      rules: {
        i1: [
          {
            required: true,
            message: "Сургалтын оноо / Кредит оруулна уу.",
            trigger: "change",
            type: "number",
            validator: validateCreditPoint,
          },
        ],
        i2: [
          {
            required: false,
            message:
              "Элссэнээс хойш сургалтыг үзэж дуусгах өдрийн тоог оруулна уу",
            trigger: "change",
            type: "number",
            validator: validateTrainingDays,
          },
        ],
        i3: [
          {
            required: false,
            message: "Анги дүүргэлтийн тоо оруулна уу",
            trigger: "change",
            type: "number",
            validator: validateMemberLimitCount,
          },
        ],
        qualityPercChanar: [
          {
            required: false,
            message: "",
            trigger: "change",
            type: "number",
            validator: validateHasPayment,
          },
        ],
        budget: [
          {
            required: true,
            message: "Сургалтын төлбөр тохируулна уу.",
            trigger: "change",
            type: "number",
            validator: validateBudget,
          },
        ],
        flagAccept: [
          {
            required: true,
            message: "*",
            trigger: "blur",
            type: "number",
            validator: validateDirectRegistration,
          },
        ],
      },
      sections: [
        {
          id: 1,
          name: "Ерөнхий",
          ord: 10,
          active: true,
          disabled: false,
          required: true,
        },
        {
          id: 2,
          name: "Хугацаа",
          ord: 20,
          active: false,
          disabled: true,
          required: true,
        },
        {
          id: 3,
          name: "Бүртгэл",
          ord: 30,
          active: false,
          disabled: true,
          required: true,
        },
        {
          id: 4,
          name: "Контент",
          ord: 40,
          active: false,
          disabled: true,
          required: false,
        },
        {
          id: 5,
          name: "Дүн тооцох",
          ord: 50,
          active: false,
          disabled: true,
          required: false,
        },
        {
          id: 6,
          name: "Төлбөр",
          ord: 60,
          active: false,
          disabled: true,
          required: false,
        },
        {
          id: 7,
          name: "Нийтлэх",
          ord: 70,
          active: false,
          disabled: true,
          required: false,
        },
      ],
      fields: [],
      taskModel: {},
      hiddenFields: true,
      otConfig: {},
      confirmDialogVisible: false,
    };
  },
  props: {
    show: {
      type: Boolean,
      default: () => false,
    },
    wd: {
      type: String,
      default: () => "95%",
    },
    prms: {
      type: Object,
      default: () => {},
    },
    disablePreEditCheck: {
      type: Boolean,
      default: () => false,
    },
    labelPosition: {
      type: String,
      default: () => "left",
    },
  },
  mounted() {
    if (hasOneOf(["lmsacademy"], this.$store.state.user.access)) {
      this.sections.push({
        id: 8,
        name: "Академи",
        ord: 80,
        active: false,
        disabled: true,
        required: false,
      });
    }

    this.init();
  },
  methods: {
    fileUploaded(e, field) {
      field.uv = false;
      this.$data["taskModel"][field.key] = e.uploadedName;
      this.$data["taskModel"][field.field] = e.uploadedAttachmentId;
      field.cstmFld1 = e.uploadedUrl;
    },
    fileUploadedProperty(e, field) {
      this.locTypeFieldOnSet(
        field.property.type,
        e.uploadedAttachmentId,
        field
      );
    },
    fileAttached(e) {
      if (this.mediaFinder.mode == 2) {
        let i = this.locTypeFields.fields
          .map((f) => f.id)
          .indexOf(this.mediaFinder.obj["id"]);
        this.locTypeFieldOnSet(
          this.locTypeFields.fields[i].property.type,
          e.id,
          this.locTypeFields.fields[i]
        );
      } else {
        this.$data["taskModel"][this.mediaFinder.obj["key"]] = e.t;
        this.$data["taskModel"][this.mediaFinder.obj["field"]] = e.id;
      }

      //this.featherReplace();
      this.mediaFinder.show = false;
    },
    diffDays() {
      var a = moment(this.taskModel.dueDate);
      var b = moment(this.taskModel.dueStartDate);
      //a.diff(b, 'days') // 1
      return a.diff(b, "days");
    },
    registrationMemberOptionChanged(field, val) {
      this.fieldShowCheck("taskEn");
    },
    onSubmitConfirm() {
      this.$refs.formValidate.validate((valid) => {
        if (valid) {
          if (this.taskModel.isPublic) {
            this.confirmDialogVisible = true;
          } else {
            this.onSubmit();
          }
        }
      });
    },
    yesNoBoolChanged(e, val) {
      if (e.field == "taskPinIs" && val == true) {
        //this.taskModel.i1=null;
        this.fields.filter((x) => x.field == "i1")[0].rule = this.rules.i1;
        this.fields.filter((x) => x.field == "d1")[0].rule.required = true;
        this.fields.filter((x) => x.field == "d2")[0].rule.required = true;
      } else if (e.field == "taskPinIs" && val == false) {
        this.fields.filter((x) => x.field == "i1")[0].rule = {
          required: false,
          message: "Сургалтын оноо / Кредит оруулна уу.",
          trigger: "change",
          type: "number",
        };
        this.fields.filter((x) => x.field == "d1")[0].rule.required = false;
        this.fields.filter((x) => x.field == "d2")[0].rule.required = false;
      }
    },
    yesNoIntChanged(e, val) {
      if (e.field == "minutes" && val == 0) {
        this.taskModel.flag1 = 0;
        this.fields.filter((x) => x.field == "i3")[0].rule = {
          required: false,
          message: "Анги дүүргэлтийн тоо оруулна уу",
          trigger: "change",
          type: "number",
        };
      } else if (e.field == "minutes" && val == 1) {
        this.taskModel.flag1 = 1;
        this.fields.filter((x) => x.field == "i3")[0].rule = this.rules.i3;
      }

      if (e.field == "qualityPercChanar" && val == 0) {
        this.taskModel.budget = 0;
        this.fields.filter((x) => x.field == "budget")[0].rule.required = false;
      } else if (e.field == "qualityPercChanar" && val == 1) {
        this.fields.filter(
          (x) => x.field == "budget"
        )[0].rule = this.rules.budget;
      }

      if (e.field == "flagAccept" && val == 0) {
        this.fields.filter(
          (x) => x.field == "flagAccept"
        )[0].rule.required = false;
      } else if (e.field == "flagAccept" && val == 1) {
        this.fields.filter(
          (x) => x.field == "flagAccept"
        )[0].rule = this.rules.flagAccept;
      }
    },
    timeCalcMethodChanged(e) {
      if (e == 9) {
        this.$nextTick(() => {
          this.fields.filter((x) => x.field == "i2")[0].rule = this.rules.i2;
        });
      } else {
        this.fields.filter((x) => x.field == "i2")[0].rule = {
          required: false,
          message:
            "Элссэнээс хойш сургалтыг үзэж дуусгах өдрийн тоог оруулна уу",
          trigger: "change",
          type: "number",
        };
      }
    },
    goToNextSection() {
      const currentIndex = this.sections.findIndex((tab) => tab.active);
      this.sections[currentIndex].active = false;
      const nextIndex = (currentIndex + 1) % this.sections.length;
      this.sections[nextIndex].active = true;
      this.activeSection = this.sections[nextIndex].id;
    },
    toggleBodyClass(addRemoveClass, className) {
      const el = document.body;
      if (addRemoveClass === "addClass") {
        el.classList.add(className);
      } else {
        el.classList.remove(className);
      }
    },
    onSubmit(obj) {
      //alert("onSubmit");
      this.$refs.formValidate.validate((valid) => {
        if (valid) {
          if (obj != undefined) {
            if (obj.isPublic != undefined) {
              this.taskModel.isPublic = obj.isPublic;
            }
          }

          //if (this.checkRequiredFields()) {
          this.taskModel.massPerc = this.activeSection;
          this.toggleBodyClass("addClass", "dynamic-locker");

          request({
            api: { url: "Task/PostInherited", method: "POST" },
            data: {
              model: this.taskModel,
            },
            store: this.$store,
          }).then((res) => {
            this.toggleBodyClass("removeClass", "dynamic-locker");
            if (res != false) {
              if (res.result == 1) {
                if (this.taskModel.id == 0 && !this.taskModel.isPublic) {
                  this.taskModel.id = res.taskId;
                  this.taskId = res.taskId;
                  // this.rdy= true;
                  this.goToNextSection();
                } else {
                  this.taskModel.id = res.taskId;
                  this.taskId = res.taskId;
                  this.toggleBodyClass("addClass", "dynamic-locker");
                  request({
                    api: { url: "task/taskInheritedDetail", method: "get" },
                    params: { id: this.taskId },
                    store: this.$store,
                  }).then((res) => {
                    this.toggleBodyClass("removeClass", "dynamic-locker");
                    if (res != false) {
                      this.taskDetail = res.data.task;
                      let activeSectionOrd = this.sections.filter(
                        (x) => x.active == true
                      )[0].ord;
                      if (this.taskModel.isPublic || activeSectionOrd == 70) {
                        this.confirmDialogVisible = false;
                        this.showSidebar = false;
                        // this.$emit("on-task-posted", {
                        //   obj: this.taskModel,
                        //   prms: this.prms,
                        //   afterMode: null,
                        // });
                      } else {
                        this.goToNextSection();
                      }

                      // this.rdy= true;
                    }
                  });
                }
              }
            }
          });
          // } else {
          //   //check requirements false
          // }
        } else {
          //form is not valid
        }
      });
    },
    fieldShowCheck(field) {
      let rv = true;
      if (field == "fourthAttachmentId") {
        rv = this.taskModel.i6 == 1;
      } else if (field == "s2") {
        rv = this.taskModel.minutes == 1;
      } else if (field == "flagAccept") {
        rv = this.taskModel.minutes == 1;
      } else if (field == "departId") {
        rv = this.taskModel.minutes == 1;
      } else if (field == "s1") {
        rv = this.taskModel.minutes == 1;
      } else if (field == "i7") {
        rv = this.taskModel.minutes == 1;
      } else if (field == "label5") {
        rv = this.taskModel.minutes == 1;
      } else if (field == "d1" || field == "d2") {
        rv = this.taskModel.taskPinIs;
      } else if (field == "d3" || field == "d4") {
        rv = this.taskModel.minutes == 1;
      } else if (field == "i1") {
        if(this.$store.state.app.activeGroup.id == 9254) {
          rv = true;
        } else {
          rv = this.taskModel.taskPinIs;
        }
        // rv = this.taskModel.taskPinIs;
      } else if (field == "i2") {
        rv = this.taskModel.flag == 9;
      } else if (field == "i3") {
        rv = this.taskModel.minutes == 1;
      } else if (field == "days") {
        rv = this.taskModel.i6 == 1;
      } else if (
        field == "courseYavtsPerc" ||
        field == "courseIrtsPerc" ||
        field == "courseExamPerc"
      ) {
        rv = this.taskModel.courseSolveResult == 1;
      } else if (field == "budget" || field == "budgetPerc") {
        rv = this.taskModel.qualityPercChanar == 1;
      } else if (field == "too1" || field == "too2" || field == "f1") {
        rv = this.taskModel.budgetPerc == 1;
      } else if (field == "taskEn") {
        //rv = this.taskModel.flag1 == 9900;
      } else if (field == "planTypeId") {
        rv = hasOneOf(["lmsacademy"], this.$store.state.user.access);
      }
      return rv;
    },
    uploaderShowCheck(field) {
      let rv = true;
      // if(field=='fourthAttachmentId'){
      //   rv=this.taskModel.i6 == 1;
      // }
      return rv;
    },
    inputShowCheck(field) {
      let rv = true;
      return rv;
    },
    areaShowCheck(field) {
      let rv = true;
      return rv;
    },
    boxShowCheck(field) {
      let rv = true;
      return rv;
    },
    dateShowCheck(field) {
      let rv = true;
      return rv;
    },
    toggleShowCheck(field) {
      let rv = true;
      return rv;
    },
    numberShowCheck(field) {
      let rv = true;
      return rv;
    },
    infoBuilder(v) {
      if (v == null) {
        return "";
      } else if (v.length <= 0) {
        return "";
      } else {
        return v;
      }
    },

    checkRequiredFields() {
      let activeSectionOrd = this.sections.filter((x) => x.active == true)[0]
        .ord;
      if (activeSectionOrd == 10) {
        if (
          this.taskModel.task == null ||
          this.taskModel.task == undefined ||
          this.taskModel.task == ""
        ) {
          Notification({
            title: "Санамж",
            message: "Та сургалтын нэрийг заавал оруулна уу.",
            type: "warning",
          });
          return false;
        }
      } else {
        return true;
      }
      return true;
    },

    changeSctn(sec) {
      this.$refs.formValidate.validate((valid) => {
        if (valid) {
          this.sections.forEach((s) => {
            s.active = s.id == sec.id;
          });
          this.activeSection = sec.id;
        }
      });
      // if(!sec.disabled){

      // }
    },
    init() {
      this.showSidebar = true;

      let preEditId = this.prms.id;
      if (preEditId == 0) {
        preEditId = -1;
      }

      this.toggleBodyClass("addClass", "dynamic-locker");
      request({
        api: { url: "task/PreEdit", method: "get" },
        params: {
          id: preEditId,
          parentId: this.prms.parentId,
          boxId: this.prms.boxId,
          objectTypeId: this.prms.objectTypeId,
          projectId: this.prms.projectId,
        },
        store: this.$store,
      }).then((res) => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if (res != false) {
          this.build();
        } else {
          this.visibleChanged(false);
        }
      });
    },
    build() {
      this.toggleBodyClass("addClass", "dynamic-locker");
      request({
        api: { url: "taskCore/getEditFields", method: "get" },
        params: {
          objectTypeId: this.prms.objectTypeId,
        },
        store: this.$store,
      }).then((res) => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if (res != false) {
          this.fields = res.data.fields;
          this.fieldsAfter();
          this.toggleBodyClass("addClass", "dynamic-locker");
          request({
            api: { url: "Task/GetInherited", method: "get" },
            params: {
              id: this.prms.id,
              parentId: this.prms.parentId,
              boxId: this.prms.boxId,
              objectTypeId: this.prms.objectTypeId,
              projectId: this.prms.projectId,
            },
            store: this.$store,
          }).then((res) => {
            this.toggleBodyClass("removeClass", "dynamic-locker");
            if (res != false) {
              if (this.prms.id == 0) {
                res.data.task.flag = 0;
                res.data.task.courseSolveResult = 0;
                res.data.task.taskPinIs = false;
                res.data.task.minutes = 0;
                res.data.task.flagAccept = 0;

                //res.data.task.dueStartDate = null;
                //res.data.task.dueDate = null;
                res.data.task.d1 = null;
                res.data.task.d2 = null;
                res.data.task.d3 = null;
                res.data.task.d4 = null;

                res.data.task.repeatWeekDay = 0;
                res.data.task.unit = 1;
                res.data.task.flag2 = 0;
                res.data.task.repeatCount = 0;
                res.data.task.repeatType = 0;
              }

              // res.data.task.taskPinIs = false;

              console.log("res.data.task", res.data.task);

              this.taskModel = res.data.task;

              if (this.prms.id == 0) {
              } else {
                this.toggleBodyClass("addClass", "dynamic-locker");
                request({
                  api: { url: "task/taskInheritedDetail", method: "get" },
                  params: { id: this.prms.id },
                  store: this.$store,
                }).then((res) => {
                  this.toggleBodyClass("removeClass", "dynamic-locker");
                  if (res != false) {
                    this.taskDetail = res.data.task;
                    if (this.taskDetail.massPerc > 0) {
                      this.changeSctn({ id: this.taskDetail.massPerc });
                    }
                    this.myLocKey++;
                  }
                });
              }

              // this.$nextTick(() => {
              //   this.$refs.formValidate.validate(); // Use the appropriate method for refreshing/validation
              // });
            }
          });
        }
      });
    },
    fieldsAfter() {
      this.fields.forEach((el) => {
        if (el.field == "taskDesc") {
          el.title = "Сургалтын товч танилцуулга";
        } else if (el.field == "taskDesc") {
          el.flag = "Сургалтын хугацаа";
        } else if (el.field == "taskPinIs" || el.field == "isPublic") {
          if (el.field == "taskPinIs") {
            el.editOrd = 30;
          }
          el.flag = 11501;
        } else if (el.field == "unit") {
          el.flag = 11502;
        } else if (
          el.field == "i6" ||
          el.field == "days" ||
          el.field == "planTypeId"
        ) {
          if (el.field == "i6") {
            el.flag = 11503;
            el.editOrd = 10;
          } else if (el.field == "days") {
            el.editOrd = 11;
          } else if (el.field == "planTypeId") {
            el.editOrd = 7010;
            el.flag = 11503;
          }
        } else if (
          el.field == "repeatType" ||
          el.field == "repeatCount" ||
          el.field == "minutes" ||
          el.field == "qualityPercChanar" ||
          el.field == "budgetPerc" ||
          el.field == "i7" ||
          el.field == "flagAccept"
        ) {
          el.flag = 11503;
          if (el.field == "qualityPercChanar") {
            el.rule = this.rules.qualityPercChanar;
          }
        } else if (el.field == "label4") {
          el.flag = 11504;
          el.editOrd = 400;
        } else if (el.field == "dueStartDate") {
          el.editOrd = 410;
        } else if (el.field == "dueDate") {
          el.editOrd = 420;
        } else if (
          el.field == "courseSolveResult" ||
          el.field == "courseYavtsPerc" ||
          el.field == "courseIrtsPerc" ||
          el.field == "courseExamPerc"
        ) {
          if (el.field == "courseSolveResult") {
            el.editOrd = 21;
          } else if (el.field == "courseYavtsPerc") {
            el.editOrd = 22;
          } else if (el.field == "courseIrtsPerc") {
            el.editOrd = 23;
          } else if (el.field == "courseExamPerc") {
            el.editOrd = 24;
          }
        } else if (el.field == "d3") {
          el.title = "Эхлэх огноо";
        } else if (el.field == "d4") {
          el.title = "Дуусах огноо";
        } else if (el.field == "fourthAttachmentId") {
          el.cstmFld1 =
            "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
        } else if (el.field == "defaultAttachmentId") {
          el.cstmFld1 = "image/jpeg, image/png, image/gif";
        } else if (el.field == "secondAttachmentId") {
          el.cstmFld1 = "image/jpeg, image/png, image/gif";
        } else if (el.field == "thirdAttachmentId") {
          el.cstmFld1 = "video/mp4";
        }

        //lms ubtz yed
        if (
          (this.$store.state.app.activeGroup.id == 9235 || this.$store.state.app.activeGroup.id == 9362) &&
          el.field == "departId"
        ) {
          el.sectionId = 3;
          el.editOrd = 341;
        }

        //24.05.28 nd neev
        if (el.field == "i4") {
          el.editOrd = 513;
        }

        //25.03.07 nd neev surgalt gov
        // if (el.field == "locTypeId4") {
        //   el.sectionId = 1;
        // }

        switch (el.field) {
          case "task":
          case "locTypeId":
          case "locTypeId1":
          case "locTypeId2":
          case "taskDesc":
          case "i5":
          case "defaultAttachmentId":
          case "secondAttachmentId":
          case "thirdAttachmentId":
            el.sectionId = 1;
            break;
          case "flag":
          case "dueStartDate":
          case "dueDate":
          case "i2":
          case "label4":
            el.sectionId = 2;
            break;
          case "minutes":
          case "flagAccept":
          case "i3":
          case "i7":
          case "d3":
          case "d4":
          case "flag1":
          case "taskEn":
          case "phone":
          case "s1":
          case "s2":
          case "label5":
            el.sectionId = 3;
            break;
          case "unit":
          case "repeatType":
          case "repeatCount":
          case "repeatWeekDay":
          case "flag2":
          case "st6":
            el.sectionId = 4;
            break;
          case "i6":
          case "days":
          case "fourthAttachmentId":
          case "courseSolveResult":
          case "courseYavtsPerc":
          case "courseIrtsPerc":
          case "courseExamPerc":
          case "taskPinIs":
          case "i1":
          case "d1":
          case "d2":
          case "i4": //24.05.28 nd neev
            el.sectionId = 5;
            break;
          case "budget":
          case "qualityPercChanar":
          case "too1":
          case "too2":
          case "f1":
          case "budgetPerc":
            el.sectionId = 6;
            break;
          case "isPublic":
            el.sectionId = 7;
            break;
          case "planTypeId":
          case "personDay":
          case "dec1":
            el.sectionId = 8;
            break;
        }
      });

      this.fields = _.orderBy(this.fields, ["editOrd"], ["asc"]);
      console.log("this.fields", this.fields, this.fields.map(el => el.field + ' '+ el.title + ' ' + el.editOrd + ' ' + el.sectionId));
    },
    visibleChanged(e) {
      if (!e) {
        //if (this.directClose) {
        this.$emit("on-task-posted", {
          obj: this.taskModel,
          prms: this.prms,
        });

        this.confirmDialogVisible = false;
        this.$nextTick(() => {
          Object.assign(this.$data, this.$options.data());
        });

        //}
        //Object.assign(this.$data, this.$options.data());

        //this.$emit("on-edit-close");
      }
    },
  },
};
</script>
<style lang="less">
.navsecs {
  .nav-link {
    &.active {
      color: #044b9d !important;
    }
  }
}
.core-edit-side-header > strong {
  display: block;
  width: 100%;
}
.course-create-form {
  .el-form-item {
    margin-bottom: 15px;

    .el-form-item__label {
      margin-bottom: 5px;
      padding-bottom: 0;
      line-height: initial;
    }

    .el-form-item__content {
      line-height: initial !important;
      .eddt-title-info {
        border-left: 3px solid rgba(72, 94, 144, 0.16);
        background: rgba(72, 94, 144, 0.05);
        line-height: 1.2;
        padding: 5px;
        margin-left: 10px;
        margin-top: 5px;
        font-style: italic;
      }
    }
  }
  .eddt-title-info {
    border-left: 3px solid rgba(72, 94, 144, 0.16);
    background: rgba(72, 94, 144, 0.05);
    line-height: 1.2;
    padding: 5px;
    margin-left: 10px;
    margin-top: 5px;
    font-style: italic;
  }
}
.el-popover {
  word-break: break-word !important;
}
</style>
